import React, {
  useState,
  useRef,
  useEffect,
  useMemo,
  useCallback,
  memo,
} from "react";
import styles from "./RightSidebar.module.css";
import arkIconLight from "../../../assets/ark_light.svg";
import arkIconDark from "../../../assets/ark_dark.svg";
import dockToRightIconLight from "../../../assets/dock_to_right_light.svg";
import dockToRightIconDark from "../../../assets/dock_to_right_dark.svg";
import infoIcon from "../../../assets/info.svg";
import chevronIconLight from "../../../assets/chevron_unit_light.svg";
import chevronIconDark from "../../../assets/chevron_unit_dark.svg";
import { BACKEND_URL } from "../../../config/backend";
// NEW:
// Add these imports with the other icon imports (around line 30-40)
import shareIconLight from "../../../assets/share_light.svg";
import shareIconDark from "../../../assets/share_dark.svg";
import privateIconLight from "../../../assets/share_light.svg";
import publicIconLight from "../../../assets/share_light.svg";
import privateIconBlack from "../../../assets/share_dark.svg";
import publicIconBlack from "../../../assets/share_dark.svg";
import privateIconWhite from "../../../assets/share_light.svg";
import publicIconWhite from "../../../assets/share_light.svg";
import privateIconDark from "../../../assets/share_dark.svg";
import publicIconDark from "../../../assets/share_dark.svg";
import checkMessagesIconLight from "../../../assets/check_messages_light.svg";
import checkMessagesIconDark from "../../../assets/check_messages_dark.svg";
import { analytics } from "../../../firebase/config";
import { logEvent } from "firebase/analytics";
import geminiIcon from "../../../assets/geminiIcon.svg";
import claudeIcon from "../../../assets/claudeIcon.svg";
import gptIconLight from "../../../assets/gptIconLight.svg";
import gptIconDark from "../../../assets/gptIconDark.svg";
import chevronActiveIconLight from "../../../assets/chevron_unit_active_light.svg";
import chevronActiveIconDark from "../../../assets/chevron_unit_active_dark.svg";
import mentionIconLight from "../../../assets/mention_light.svg";
import mentionIconDark from "../../../assets/mention_dark.svg";
import mentionActiveIconLight from "../../../assets/mention_light_active.svg";
import mentionActiveIconDark from "../../../assets/mention_dark_active.svg";
import unitIconActiveLight from "../../../assets/unit_active_light.svg";
import unitIconActiveDark from "../../../assets/unit_active_dark.svg";
import warningIconLight from "../../../assets/warn_light.svg";
import warningIconDark from "../../../assets/warn_dark.svg";
import unitIconLight from "../../../assets/unit_light.svg";
import unitIconDark from "../../../assets/unit_dark.svg";
import closeIconLight from "../../../assets/small_close_light.svg";
import closeIconDark from "../../../assets/small_close_dark.svg";
import selectedActiveIconLight from "../../../assets/selection_active_light.svg";
import selectedActiveIconDark from "../../../assets/selection_active_dark.svg";
import featureIconLight from "../../../assets/feature_light.svg"; // ADD THIS
import featureIconDark from "../../../assets/feature_dark.svg"; // ADD THIS
import brainIconLight from "../../../assets/brain_light.svg";
import brainIconDark from "../../../assets/brain_dark.svg";
import glossaryIconLight from "../../../assets/glossary_light.svg";
import glossaryIconDark from "../../../assets/glossary_dark.svg";
import selectionIconLight from "../../../assets/selection_light.svg";
import selectionIconDark from "../../../assets/selection_dark.svg";
import sendIconLight from "../../../assets/send_light.svg";
import sendIconDark from "../../../assets/send_dark.svg";
import sendIconDisabledLight from "../../../assets/send_disabled_light.svg";
import sendIconDisabledDark from "../../../assets/send_disabled_dark.svg";
import loadingIconLight from "../../../assets/loading_light.svg";
import loadingIconDark from "../../../assets/loading_dark.svg";

import diffusionIcon from "../../../assets/loading.svg";
import stopIconLight from "../../../assets/stop_light.svg";
import stopIconDark from "../../../assets/stop_dark.svg";

import createIconLight from "../../../assets/create_light.svg";
import createIconDark from "../../../assets/create_dark.svg";

import modifyIconLight from "../../../assets/modify_light.svg";
import modifyIconDark from "../../../assets/modify_dark.svg";

import deleteIconLight from "../../../assets/delete_light.svg";
import deleteIconDark from "../../../assets/delete_dark.svg";
import errorIcon from "../../../assets/error.svg";
import copyIconLight from "../../../assets/copy_message_light.svg";
import copyIconDark from "../../../assets/copy_message_dark.svg";

import checkIconLight from "../../../assets/check_messages_light.svg";
import checkIconDark from "../../../assets/check_messages_dark.svg";

import thumbsUpIconLight from "../../../assets/thumbs_up_light.svg";
import thumbsUpIconDark from "../../../assets/thumbs_up_dark.svg";

import thumbsUpFillIconLight from "../../../assets/thumbs_up_fill_light.svg";
import thumbsUpFillIconDark from "../../../assets/thumbs_up_fill_dark.svg";

import thumbsDownIconLight from "../../../assets/thumbs_down_light.svg";
import thumbsDownIconDark from "../../../assets/thumbs_down_dark.svg";
import thumbsDownFillLight from "../../../assets/thumbs_down_fill_light.svg";
import thumbsDownFillDark from "../../../assets/thumbs_down_fill_dark.svg";

import thumbsDownFillIcon from "../../../assets/thumbs_down_fill.svg";
import retryIcon from "../../../assets/retry.svg";
import restoreIconLight from "../../../assets/restore_light.svg";
import restoreIconDark from "../../../assets/restore_dark.svg";

import { useAuth } from "../../../components/Auth/AuthProvider";
import { useThemedIcon } from "../../../hooks/useThemedIcon";
import { db } from "../../../firebase/config";
import {
  collection,
  query,
  where,
  getDocs,
  addDoc,
  updateDoc,
  doc,
} from "firebase/firestore";
import UserGuideModal from "../../../components/UserGuide/UserGuideModal";

// Add this helper function at the top of the file, outside the component
const testStickySession = async (branchId: string): Promise<boolean> => {
  try {
    // Request 1: Get document state and note the response time
    const req1Start = Date.now();
    const response1 = await fetch(`${BACKEND_URL}/api/command`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        user_input: "DEBUG_DOCUMENT_STATE",
        context: {},
        branch_id: branchId,
      }),
      signal: AbortSignal.timeout(300000),
    });
    const req1Time = Date.now() - req1Start;

    if (!response1.ok) return false;
    const result1 = await response1.json();

    // Small delay
    await new Promise((resolve) => setTimeout(resolve, 100));

    // Request 2: Get document state again
    const req2Start = Date.now();
    const response2 = await fetch(`${BACKEND_URL}/api/command`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        user_input: "DEBUG_DOCUMENT_STATE",
        context: {},
        branch_id: branchId,
      }),
      signal: AbortSignal.timeout(300000),
    });
    const req2Time = Date.now() - req2Start;

    if (!response2.ok) return false;
    const result2 = await response2.json();

    // If we're hitting the same pod:
    // 1. Response times should be similar (within 500ms)
    // 2. Document state should be identical (same object count, same bodies)

    const timeDiff = Math.abs(req1Time - req2Time);
    const sameObjectCount =
      result1.debug_data?.total_objects === result2.debug_data?.total_objects;
    const sameBodiesCount =
      result1.debug_data?.bodies?.length === result2.debug_data?.bodies?.length;

    const sameSession = timeDiff < 500 && sameObjectCount && sameBodiesCount;

    // console.log(
    //   `🏷️ STICKY SESSION TEST: ${
    //     sameSession ? "✅ SAME POD" : "❌ DIFFERENT POD"
    //   }`
    // );
    // console.log(
    //   `   - Response times: ${req1Time}ms vs ${req2Time}ms (diff: ${timeDiff}ms)`
    // );
    // console.log(
    //   `   - Objects: ${result1.debug_data?.total_objects} vs ${result2.debug_data?.total_objects}`
    // );
    // console.log(
    //   `   - Bodies: ${result1.debug_data?.bodies?.length} vs ${result2.debug_data?.bodies?.length}`
    // );

    return sameSession;
  } catch (error) {
    // console.warn("Sticky session test failed:", error);
    return false;
  }
};

const getContextualLoadingMessages = (userInput: string): string[] => {
  const input = userInput.toLowerCase();

  // ==================== DELETE OPERATIONS ====================
  if (input.includes("delete") || input.includes("remove")) {
    // Check what type of feature is being deleted
    if (input.includes("fillet") || /fillet\d+/i.test(input)) {
      return [
        "Locating fillet",
        "Analyzing dependencies",
        "Removing blend",
        "Recomputing geometry",
        "Finalizing deletion",
      ];
    }

    if (input.includes("chamfer") || /chamfer\d+/i.test(input)) {
      return [
        "Locating chamfer",
        "Analyzing dependencies",
        "Removing bevel",
        "Recomputing geometry",
        "Finalizing deletion",
      ];
    }

    if (input.includes("pocket") || /pocket\d+/i.test(input)) {
      return [
        "Locating cut",
        "Analyzing dependencies",
        "Restoring material",
        "Recomputing model",
        "Finalizing deletion",
      ];
    }

    if (input.includes("hole") || /hole\d+/i.test(input)) {
      return [
        "Locating hole",
        "Analyzing dependencies",
        "Filling hole",
        "Recomputing geometry",
        "Finalizing deletion",
      ];
    }

    if (
      input.includes("pad") ||
      /pad\d+/i.test(input) ||
      input.includes("extrude")
    ) {
      return [
        "Locating extrude",
        "Analyzing dependencies",
        "Removing extrusion",
        "Recomputing model",
        "Finalizing deletion",
      ];
    }

    if (input.includes("groove") || /groove\d+/i.test(input)) {
      return [
        "Locating groove",
        "Analyzing dependencies",
        "Removing cut",
        "Recomputing geometry",
        "Finalizing deletion",
      ];
    }

    if (input.includes("draft") || /draft\d+/i.test(input)) {
      return [
        "Locating draft",
        "Analyzing dependencies",
        "Removing taper",
        "Recomputing faces",
        "Finalizing deletion",
      ];
    }

    if (input.includes("box") || /box\d+/i.test(input)) {
      return [
        "Locating box",
        "Analyzing dependencies",
        "Removing solid",
        "Updating document",
        "Finalizing deletion",
      ];
    }

    if (input.includes("cylinder") || /cylinder\d+/i.test(input)) {
      return [
        "Locating cylinder",
        "Analyzing dependencies",
        "Removing solid",
        "Updating document",
        "Finalizing deletion",
      ];
    }

    if (input.includes("sphere") || /sphere\d+/i.test(input)) {
      return [
        "Locating sphere",
        "Analyzing dependencies",
        "Removing solid",
        "Updating document",
        "Finalizing deletion",
      ];
    }

    // Generic delete
    return [
      "Locating feature",
      "Analyzing dependencies",
      "Removing feature",
      "Recomputing model",
      "Finalizing deletion",
    ];
  }

  // ==================== EDIT/CHANGE OPERATIONS ====================
  if (
    input.includes("edit") ||
    input.includes("change") ||
    input.includes("modify") ||
    input.includes("resize") ||
    input.includes("adjust")
  ) {
    // Check what type of feature is being edited
    if (input.includes("fillet") || /fillet\d+/i.test(input)) {
      return [
        "Analyzing fillet",
        "Updating radius",
        "Recalculating blend",
        "Refining surface",
        "Finalizing edit",
      ];
    }

    if (input.includes("chamfer") || /chamfer\d+/i.test(input)) {
      return [
        "Analyzing chamfer",
        "Updating distance",
        "Recalculating bevel",
        "Refining edges",
        "Finalizing edit",
      ];
    }

    if (input.includes("pocket") || /pocket\d+/i.test(input)) {
      return [
        "Analyzing cut",
        "Updating depth",
        "Recalculating cut",
        "Recomputing geometry",
        "Finalizing edit",
      ];
    }

    if (input.includes("hole") || /hole\d+/i.test(input)) {
      return [
        "Analyzing hole",
        "Updating parameters",
        "Recalculating depth",
        "Refining geometry",
        "Finalizing edit",
      ];
    }

    if (
      input.includes("pad") ||
      /pad\d+/i.test(input) ||
      input.includes("extrude")
    ) {
      return [
        "Analyzing extrude",
        "Updating length",
        "Recalculating extrusion",
        "Recomputing solid",
        "Finalizing edit",
      ];
    }

    if (input.includes("groove") || /groove\d+/i.test(input)) {
      return [
        "Analyzing groove",
        "Updating profile",
        "Recalculating cut",
        "Recomputing geometry",
        "Finalizing edit",
      ];
    }

    if (input.includes("draft") || /draft\d+/i.test(input)) {
      return [
        "Analyzing draft",
        "Updating angle",
        "Recalculating taper",
        "Adjusting faces",
        "Finalizing edit",
      ];
    }

    if (input.includes("box") || /box\d+/i.test(input)) {
      return [
        "Analyzing box",
        "Updating dimensions",
        "Recalculating geometry",
        "Rebuilding solid",
        "Finalizing edit",
      ];
    }

    if (input.includes("cylinder") || /cylinder\d+/i.test(input)) {
      return [
        "Analyzing cylinder",
        "Updating dimensions",
        "Recalculating geometry",
        "Rebuilding solid",
        "Finalizing edit",
      ];
    }

    if (input.includes("sphere") || /sphere\d+/i.test(input)) {
      return [
        "Analyzing sphere",
        "Updating radius",
        "Recalculating geometry",
        "Rebuilding solid",
        "Finalizing edit",
      ];
    }

    // Generic edit
    return [
      "Analyzing feature",
      "Updating parameters",
      "Recalculating geometry",
      "Recomputing model",
      "Finalizing edit",
    ];
  }

  // ==================== MOVE/POSITION OPERATIONS ====================
  if (
    input.includes("move") ||
    input.includes("position") ||
    input.includes("translate") ||
    input.includes("shift")
  ) {
    // Check what type of feature is being moved
    if (input.includes("fillet") || /fillet\d+/i.test(input)) {
      return [
        "Locating fillet",
        "Calculating new position",
        "Updating blend location",
        "Recomputing geometry",
        "Finalizing position",
      ];
    }

    if (input.includes("chamfer") || /chamfer\d+/i.test(input)) {
      return [
        "Locating chamfer",
        "Calculating new position",
        "Updating bevel location",
        "Recomputing geometry",
        "Finalizing position",
      ];
    }

    if (input.includes("pocket") || /pocket\d+/i.test(input)) {
      return [
        "Locating cut",
        "Calculating new position",
        "Updating cut location",
        "Recomputing geometry",
        "Finalizing position",
      ];
    }

    if (input.includes("hole") || /hole\d+/i.test(input)) {
      return [
        "Locating hole",
        "Calculating new position",
        "Updating drill point",
        "Recomputing geometry",
        "Finalizing position",
      ];
    }

    if (
      input.includes("pad") ||
      /pad\d+/i.test(input) ||
      input.includes("extrude")
    ) {
      return [
        "Locating extrude",
        "Calculating new position",
        "Updating extrusion placement",
        "Recomputing model",
        "Finalizing position",
      ];
    }

    if (input.includes("groove") || /groove\d+/i.test(input)) {
      return [
        "Locating groove",
        "Calculating new position",
        "Updating cut placement",
        "Recomputing geometry",
        "Finalizing position",
      ];
    }

    if (input.includes("box") || /box\d+/i.test(input)) {
      return [
        "Locating box",
        "Calculating translation",
        "Updating position",
        "Recomputing placement",
        "Finalizing position",
      ];
    }

    if (input.includes("cylinder") || /cylinder\d+/i.test(input)) {
      return [
        "Locating cylinder",
        "Calculating translation",
        "Updating position",
        "Recomputing placement",
        "Finalizing position",
      ];
    }

    if (input.includes("sphere") || /sphere\d+/i.test(input)) {
      return [
        "Locating sphere",
        "Calculating translation",
        "Updating position",
        "Recomputing placement",
        "Finalizing position",
      ];
    }

    // Generic move
    return [
      "Locating feature",
      "Calculating new position",
      "Updating placement",
      "Recomputing model",
      "Finalizing position",
    ];
  }

  // ==================== CREATE OPERATIONS ====================

  // Hole operations (specific drilling/boring)
  if (
    input.includes("hole") ||
    input.includes("drill") ||
    input.includes("bore") ||
    input.includes("countersink") ||
    input.includes("counterbore")
  ) {
    return [
      "Analyzing target face",
      "Calculating hole depth",
      "Positioning drill point",
      "Creating hole geometry",
      "Finalizing hole",
    ];
  }

  // Pocket operations (generic material removal)
  if (
    input.includes("pocket") ||
    input.includes("recess") ||
    input.includes("cavity")
  ) {
    return [
      "Analyzing surface",
      "Calculating cut depth",
      "Positioning cut",
      "Removing material",
      "Finalizing cut",
    ];
  }

  // Fillet operations
  if (input.includes("fillet") || input.includes("round")) {
    return [
      "Detecting edges",
      "Calculating blend radius",
      "Smoothing transitions",
      "Refining surface",
      "Finalizing fillets",
    ];
  }

  // Chamfer operations
  if (input.includes("chamfer") || input.includes("bevel")) {
    return [
      "Selecting edges",
      "Calculating chamfer angle",
      "Creating bevels",
      "Refining transitions",
      "Finalizing chamfers",
    ];
  }

  // Draft operations
  if (input.includes("draft") || input.includes("taper")) {
    return [
      "Analyzing faces",
      "Calculating draft angle",
      "Applying taper",
      "Adjusting surfaces",
      "Finalizing draft",
    ];
  }

  // Groove operations
  if (input.includes("groove") || input.includes("slot")) {
    return [
      "Positioning groove",
      "Calculating profile",
      "Revolving cut",
      "Refining edges",
      "Finalizing groove",
    ];
  }

  // Extrude/Pad operations
  if (
    input.includes("extrude") ||
    input.includes("pad") ||
    input.includes("protrude")
  ) {
    return [
      "Analyzing sketch",
      "Calculating extrusion",
      "Building volume",
      "Adding material",
      "Finalizing extrude",
    ];
  }

  // Thickness/Shell/Hollow operations
  if (
    input.includes("thickness") ||
    input.includes("shell") ||
    input.includes("hollow")
  ) {
    return [
      "Analyzing solid",
      "Calculating wall thickness",
      "Creating hollow interior",
      "Refining walls",
      "Finalizing shell",
    ];
  }

  // Box creation
  if (
    input.includes("box") ||
    input.includes("cube") ||
    input.includes("rectangular")
  ) {
    return [
      "Calculating dimensions",
      "Generating box geometry",
      "Building solid",
      "Finalizing box",
    ];
  }

  // Cylinder creation
  if (
    input.includes("cylinder") ||
    input.includes("tube") ||
    input.includes("pipe")
  ) {
    return [
      "Calculating radius",
      "Generating cylindrical form",
      "Building solid",
      "Finalizing cylinder",
    ];
  }

  // Sphere creation
  if (input.includes("sphere") || input.includes("ball")) {
    return [
      "Calculating radius",
      "Generating spherical surface",
      "Building solid",
      "Finalizing sphere",
    ];
  }

  // Torus creation
  if (
    input.includes("torus") ||
    input.includes("donut") ||
    input.includes("ring")
  ) {
    return [
      "Calculating major radius",
      "Calculating minor radius",
      "Building toroidal form",
      "Finalizing torus",
    ];
  }

  // Ellipsoid creation
  if (input.includes("ellipsoid") || input.includes("oval")) {
    return [
      "Calculating axes lengths",
      "Generating ellipsoidal surface",
      "Building solid",
      "Finalizing ellipsoid",
    ];
  }

  // Prism creation
  if (input.includes("prism")) {
    return [
      "Calculating polygon base",
      "Generating prism geometry",
      "Building solid",
      "Finalizing prism",
    ];
  }

  // Wedge creation
  if (input.includes("wedge")) {
    return [
      "Calculating angles",
      "Generating wedge geometry",
      "Building solid",
      "Finalizing wedge",
    ];
  }

  // Default messages
  return [
    "Analyzing geometry",
    "Building model",
    "Calculating parameters",
    "Rendering updates",
    "Finalizing changes",
  ];
};

function useTypingEffect(
  text: string,
  speed: number = 30,
  shouldType: boolean = true,
) {
  const [displayText, setDisplayText] = useState("");
  const [isComplete, setIsComplete] = useState(false);
  const hasTypedRef = useRef(false);

  useEffect(() => {
    if (!text || !shouldType) {
      setDisplayText(text || "");
      setIsComplete(!!text);
      return;
    }

    if (hasTypedRef.current && displayText === text) {
      setIsComplete(true);
      return;
    }

    if (!hasTypedRef.current) {
      setDisplayText("");
      setIsComplete(false);
      hasTypedRef.current = true;
    }

    let index = 0;
    const timer = setInterval(() => {
      if (index < text.length) {
        setDisplayText(text.slice(0, index + 1));
        index++;
      } else {
        setIsComplete(true);
        clearInterval(timer);
      }
    }, speed);

    return () => clearInterval(timer);
  }, [text, speed, shouldType]);

  useEffect(() => {
    if (text !== displayText && text) {
      hasTypedRef.current = false;
    }
  }, [text]);

  return { displayText, isComplete };
}

function useLoadingSequence(isLoading: boolean, userInput?: string) {
  const [currentMessage, setCurrentMessage] = useState("Tinkering");
  const [messageIndex, setMessageIndex] = useState(0);
  const [loadingMessages, setLoadingMessages] = useState<string[]>([
    "Tinkering",
  ]);

  // Update messages when user input changes
  useEffect(() => {
    if (userInput) {
      const contextualMessages = getContextualLoadingMessages(userInput);
      setLoadingMessages(contextualMessages);
      setMessageIndex(0);
      setCurrentMessage(contextualMessages[0]);
    }
  }, [userInput]);

  useEffect(() => {
    if (!isLoading) {
      setMessageIndex(0);
      setCurrentMessage("Tinkering");
      return;
    }

    let timeoutId: NodeJS.Timeout;

    const scheduleNext = (index: number) => {
      // Don't schedule if we're at the last message
      if (index >= loadingMessages.length - 1) {
        return;
      }

      // Vary timing: first message stays longer, then speeds up, then slows at end
      let delay = 2000;
      if (index === 0)
        delay = 3500; // First message stays a bit longer (was 2500)
      else if (index === loadingMessages.length - 2)
        delay = 3800; // Second-to-last takes longer (was 2800)
      else delay = 2800 + Math.random() * 400; // Vary middle messages: 2.8-3.2s (was 1.8-2.2s)

      timeoutId = setTimeout(() => {
        setMessageIndex((prevIndex) => {
          const nextIndex = prevIndex + 1;
          if (nextIndex < loadingMessages.length) {
            setCurrentMessage(loadingMessages[nextIndex]);
            scheduleNext(nextIndex);
          }
          return nextIndex;
        });
      }, delay);
    };

    scheduleNext(0);

    return () => clearTimeout(timeoutId);
  }, [isLoading, loadingMessages]);

  return currentMessage;
}

interface ChatMessage {
  id: number;
  type: "user" | "assistant";
  content: string;
  originalContent?: string;
  responseType?: "create" | "modify" | "delete" | "error";
  featureName?: string;
  backendMessageId?: number;
  thinkingDuration?: string;
  aiResponseText?: string;
  // ADD THIS:
  selectionContext?: {
    edges: number;
    faces: number;
  };
}

interface CommandHistoryEntry {
  userInput: string;
  originalUserInput: string;
  selectionContext: any[];
  messageId: number;
  timestamp: number;
  browserSelectionData?: {
    edges?: Array<{
      index: number;
      coordinates: number[];
      length: number;
      object: string;
    }>;
    faces?: Array<{
      index: number;
      center: number[];
      normal: number[];
      area: number;
      object: string;
    }>;
  };
  // ADD THIS LINE:
  fullSelectionContext?: any;
}

interface OperationVersionInfo {
  current: number;
  total: number;
  canGoBack: boolean;
  canGoForward: boolean;
}

interface TreeItem {
  id: string;
  name: string;
  displayName?: string;
  type: "create" | "modify" | "delete";
  children?: TreeItem[];
  parentId?: string;
}

// REPLACE the existing RightSidebarProps interface
interface RightSidebarProps {
  onDockToggle: () => void;
  currentSelection?: string | any[];
  projectId?: string | null;
  onSelectionClear?: () => void;
  onProjectCreated?: (projectId: string) => void;
  activeModelId?: string | null;
  openModels?: Array<{ id: string; name: string }>; // Add this line
  onTabRename?: (tabId: string, newName: string) => void; // Add this line
  onShapeCreated?: (
    geometryData?: any[],
    onSaveComplete?: () => void,
    bypassDefer?: boolean,
  ) => void;
  onSuccessfulOperation?: () => void;
  isProjectPublic?: boolean;
  projectShareToken?: string;
  onShareStatusChange?: () => void;
  onCommandStart?: () => void;
  onCommandEnd?: () => void;
  onFeatureCreated?: (
    featureName: string,
    operationType: "create" | "modify" | "delete",
    messageId?: number,
    commandEntry?: CommandHistoryEntry,
  ) => string;
  onProcessUserInput?: (userInput: string) => string;
  onProcessAIResponse?: (response: string) => string;
  onRestoreToOperation?: (messageId: number) => Promise<void>;
  onNavigateOperationVersion?: (
    messageId: number,
    direction: "back" | "forward",
  ) => Promise<void>;
  getOperationVersionInfo?: (messageId: number) => OperationVersionInfo | null;
  isInVersionMode?: () => boolean;
  getVersionedOperations?: () => { [messageId: number]: any };
  onChatMessagesChange?: (messages: ChatMessage[]) => void;
  currentBranch?: string;
  onBranchChange?: (branch: string) => void;
  onShowCreditsModal?: () => void;
  isModelLoading?: boolean;
  isSharedView?: boolean;
  isActiveTabShared?: boolean;
  noahGeometry?: any[];
  isPendingSave?: boolean;
  featureTree?: TreeItem[];
  onLoadingChange?: (isLoading: boolean) => void;
  currentMeasurement?: number;
  onButtonLoadingChange?: (isLoading: boolean) => void;
  selectedUnit?: string; // ← ADD THIS LINE
  onUnitChange?: (unit: string) => void; // ← ADD THIS LINE
  onInitialCreationError?: (projectId: string) => void;
}
interface SelectionContext {
  objects: Array<{ name: string; type?: string }>;
  history: string[];
  last_created: string;
  selection: Array<{
    type: "edges" | "faces";
    object: string;
    indices: number[];
    count: number;
    browser_coordinates?: number[][];
    browser_face_data?: {
      center: number[];
      normal: number[];
      area: number;
    };
  }>;
}

const TypingMessage = memo(
  ({
    message,
    isCurrentlyTyping,
    typingText,
    getResponseIcon,
    styles,
    handleCopyMessage,
    handleThumbsUp,
    handleThumbsDown,
    handleRetry,
    copiedMessageStates,
    thumbsStates,
    isLastMessageGroup,
    tooltipStates,
    handleTooltipShow,
    handleTooltipHide,
    onRestoreToOperation,
    onNavigateOperationVersion,
    getOperationVersionInfo,
    loadingButtons,
    setLoadingButtons,
    onRemoveErrorMessages,
    isActiveTabShared,
    isAnyButtonLoading,
  }: {
    message: ChatMessage;
    isCurrentlyTyping: boolean;
    typingText: string;
    getResponseIcon: (type: string) => string;
    styles: any;
    handleCopyMessage: (messageId: number, content: string) => void;
    handleThumbsUp: (messageId: number) => void;
    handleThumbsDown: (messageId: number) => void;
    handleRetry: (messageId: number) => void;
    copiedMessageStates: { [key: number]: boolean };
    thumbsStates: { [key: number]: { up: boolean; down: boolean } };
    isLastMessageGroup: boolean;
    tooltipStates: { [key: string]: boolean };
    handleTooltipShow: (tooltipKey: string) => void;
    handleTooltipHide: (tooltipKey: string) => void;
    onRestoreToOperation?: (messageId: number) => Promise<void>;
    onNavigateOperationVersion?: (
      messageId: number,
      direction: "back" | "forward",
    ) => Promise<void>;
    getOperationVersionInfo?: (
      messageId: number,
    ) => OperationVersionInfo | null;
    loadingButtons: { [key: string]: boolean };
    setLoadingButtons: React.Dispatch<
      React.SetStateAction<{ [key: string]: boolean }>
    >;
    onRemoveErrorMessages?: () => void;
    isActiveTabShared?: boolean;
    isAnyButtonLoading: boolean;
  }) => {
    const { getIcon } = useThemedIcon();

    const copyIcon = getIcon(copyIconLight, copyIconDark);
    const checkIcon = getIcon(checkIconLight, checkIconDark);
    const thumbsUpIcon = getIcon(thumbsUpIconLight, thumbsUpIconDark);
    const restoreIcon = getIcon(restoreIconLight, restoreIconDark);
    const thumbsDownIcon = getIcon(thumbsDownIconLight, thumbsDownIconDark);
    const thumbsDownFillIcon = getIcon(thumbsDownFillLight, thumbsDownFillDark);
    const loadingIcon = getIcon(loadingIconLight, loadingIconDark);
    const chevronIcon = getIcon(chevronIconLight, chevronIconDark);

    const thumbsUpFillIcon = getIcon(
      thumbsUpFillIconLight,
      thumbsUpFillIconDark,
    );
    const stopIcon = getIcon(stopIconLight, stopIconDark);

    const createIcon = getIcon(createIconLight, createIconDark);
    const modifyIcon = getIcon(modifyIconLight, modifyIconDark);
    const [localActionsShown, setLocalActionsShown] = useState(false);
    const actionsShownRef = useRef(false);
    const messageIdRef = useRef(message.id);

    const [selectedMentionIndex, setSelectedMentionIndex] = useState(0);
    useEffect(() => {
      if (messageIdRef.current !== message.id) {
        messageIdRef.current = message.id;
        actionsShownRef.current = false;
        setLocalActionsShown(false);
      }
    }, [message.id]);

    const textToType = isCurrentlyTyping ? typingText : "";

    const { displayText, isComplete } = useTypingEffect(
      textToType,
      40,
      isCurrentlyTyping && !!typingText,
    );

    useEffect(() => {
      if (
        isComplete &&
        isCurrentlyTyping &&
        typingText &&
        typingText.length > 0 &&
        !actionsShownRef.current
      ) {
        actionsShownRef.current = true;
        setTimeout(() => {
          setLocalActionsShown(true);
        }, 200);
      }
    }, [isComplete, isCurrentlyTyping, typingText]);

    useEffect(() => {
      if (!isCurrentlyTyping && actionsShownRef.current) {
        actionsShownRef.current = false;
        setLocalActionsShown(false);
      }
    }, [isCurrentlyTyping]);

    const isCopied = copiedMessageStates[message.id];
    const thumbsState = thumbsStates[message.id] || { up: false, down: false };

    const handleRestoreClick = async () => {
      const buttonKey = `restore-${message.id}`;

      // Set loading state IMMEDIATELY
      setLoadingButtons((prev) => ({
        ...prev,
        [buttonKey]: true,
      }));

      try {
        await onRestoreToOperation?.(message.id);

        // ✅ ADD THIS: Wait for the new tab to fully load
        await new Promise((resolve) => setTimeout(resolve, 1000));

        // ✅ ADD THIS: Trigger sidebar refresh after successful branch
        if ((window as any).__refreshSidebarProjects) {
          await (window as any).__refreshSidebarProjects();
        }
      } catch (error) {
        console.error("❌ RESTORE: Restore failed:", error);
      } finally {
        // Wait a bit to ensure UI has updated
        await new Promise((resolve) => setTimeout(resolve, 100));

        // Clear loading state - restore AND save are now complete
        setLoadingButtons((prev) => ({
          ...prev,
          [buttonKey]: false,
        }));

        // ✅ ADD THIS - Force update to ensure state propagates
        setTimeout(() => {
          setLoadingButtons((prev) => ({ ...prev }));
        }, 50);
      }
    };

    const handleVersionNavigate = async (direction: "back" | "forward") => {
      const buttonKey = `${direction === "back" ? "previous" : "next"}-${
        message.id
      }`;

      // Set loading state IMMEDIATELY
      setLoadingButtons((prev) => ({
        ...prev,
        [buttonKey]: true,
      }));

      handleTooltipHide(
        `${direction === "back" ? "previous" : "next"}-${message.id}`,
      );

      // Remove error messages when navigating versions
      onRemoveErrorMessages?.();

      // Force render to show loading icon
      await new Promise((resolve) => setTimeout(resolve, 0));

      try {
        // This will trigger the entire navigation process
        await onNavigateOperationVersion?.(message.id, direction);
      } catch (error) {
        // console.error("Navigation failed:", error);
      } finally {
        // Wait a bit longer to ensure backend has stabilized
        await new Promise((resolve) => setTimeout(resolve, 500));

        // Clear loading state
        setLoadingButtons((prev) => ({
          ...prev,
          [buttonKey]: false,
        }));
      }
    };

    return (
      <>
        <div
          className={`${styles.assistantMessage} ${
            message.responseType === "error" ? styles.errorMessage : ""
          }`}
        >
          {/* Only show icon for non-error messages */}
          {message.responseType !== "error" && (
            <img
              src={getResponseIcon(message.responseType!)}
              alt={message.responseType}
              className={styles.responseIcon}
            />
          )}
          <span className={styles.assistantMessageText}>
            {isCurrentlyTyping ? displayText : message.content}
          </span>
          {/* Add Retry button for error messages */}
          {message.responseType === "error" && !isActiveTabShared && (
            <button
              className={styles.retryButton}
              onClick={() => handleRetry(message.id)}
            >
              Retry
            </button>
          )}
        </div>
        {isCurrentlyTyping && localActionsShown && isComplete && (
          <div
            className={`${styles.messageActions} ${styles.fadeIn}`}
            key={`actions-${message.id}`}
          >
            {/* ADD THIS CONDITION - only show copy/thumbs if NOT error AND NOT shared view */}
            {!isActiveTabShared && message.responseType !== "error" && (
              <>
                <button
                  className={styles.actionButton}
                  onClick={() => handleCopyMessage(message.id, message.content)}
                  onMouseEnter={() => {
                    // Don't show tooltip if already copied
                    if (!copiedMessageStates[message.id]) {
                      handleTooltipShow(`copy-${message.id}`);
                    }
                  }}
                  onMouseLeave={() => handleTooltipHide(`copy-${message.id}`)}
                >
                  <img
                    src={isCopied ? checkIcon : copyIcon}
                    alt={isCopied ? "Copied" : "Copy"}
                    className={styles.actionIcon}
                  />
                  {tooltipStates[`copy-${message.id}`] &&
                    !copiedMessageStates[message.id] && (
                      <div className={styles.tooltip}>Copy</div>
                    )}
                </button>
                <button
                  className={styles.actionButton}
                  onClick={() => handleThumbsUp(message.id)}
                  onMouseEnter={() =>
                    handleTooltipShow(`thumbsup-${message.id}`)
                  }
                  onMouseLeave={() =>
                    handleTooltipHide(`thumbsup-${message.id}`)
                  }
                >
                  <img
                    src={thumbsState.up ? thumbsUpFillIcon : thumbsUpIcon}
                    alt="Thumbs up"
                    className={styles.actionIcon}
                  />
                  {tooltipStates[`thumbsup-${message.id}`] && (
                    <div className={styles.tooltip}>Good response</div>
                  )}
                </button>
                <button
                  className={styles.actionButton}
                  onClick={() => handleThumbsDown(message.id)}
                  onMouseEnter={() =>
                    handleTooltipShow(`thumbsdown-${message.id}`)
                  }
                  onMouseLeave={() =>
                    handleTooltipHide(`thumbsdown-${message.id}`)
                  }
                >
                  <img
                    src={thumbsState.down ? thumbsDownFillIcon : thumbsDownIcon}
                    alt="Thumbs down"
                    className={styles.actionIcon}
                  />
                  {tooltipStates[`thumbsdown-${message.id}`] && (
                    <div className={styles.tooltip}>Bad response</div>
                  )}
                </button>
              </>
            )}

            {(() => {
              const versionInfo = getOperationVersionInfo
                ? getOperationVersionInfo(message.id)
                : null;

              if (versionInfo) {
                // SHOW version navigation (back/forward) for BOTH owners and viewers
                if (versionInfo.current > 1 && versionInfo.canGoBack) {
                  const buttonKey = `previous-${message.id}`;
                  const isLoading = loadingButtons[buttonKey];

                  return (
                    <div className={styles.versionControls}>
                      <button
                        className={`${styles.versionButton} ${styles.backButton}`}
                        onClick={() => handleVersionNavigate("back")}
                        onMouseEnter={() => {
                          if (!loadingButtons[`previous-${message.id}`]) {
                            handleTooltipShow(`previous-${message.id}`);
                          }
                        }}
                        onMouseLeave={() => {
                          if (!loadingButtons[`previous-${message.id}`]) {
                            handleTooltipHide(`previous-${message.id}`);
                          }
                        }}
                        disabled={isLoading}
                      >
                        {isLoading ? (
                          <img
                            src={loadingIcon}
                            alt="Loading"
                            className={`${styles.versionIcon} ${styles.spinning}`}
                          />
                        ) : (
                          <img
                            src={chevronIcon}
                            alt="Previous"
                            className={`${styles.versionIcon} ${styles.chevronLeft}`}
                          />
                        )}
                        {tooltipStates[`previous-${message.id}`] &&
                          !isLoading && (
                            <div className={styles.tooltip}>Previous</div>
                          )}
                      </button>
                      <span className={styles.versionIndicator}>
                        {versionInfo.current}/{versionInfo.total}
                      </span>
                    </div>
                  );
                } else if (
                  versionInfo.current < versionInfo.total &&
                  versionInfo.canGoForward
                ) {
                  const buttonKey = `next-${message.id}`;
                  const isLoading = loadingButtons[buttonKey];

                  return (
                    <div className={styles.versionControls}>
                      <span className={styles.versionIndicator}>
                        {versionInfo.current}/{versionInfo.total}
                      </span>
                      <button
                        className={`${styles.versionButton} ${styles.forwardButton}`}
                        onClick={() => handleVersionNavigate("forward")}
                        onMouseEnter={() => {
                          if (!loadingButtons[`next-${message.id}`]) {
                            handleTooltipShow(`next-${message.id}`);
                          }
                        }}
                        onMouseLeave={() => {
                          if (!loadingButtons[`next-${message.id}`]) {
                            handleTooltipHide(`next-${message.id}`);
                          }
                        }}
                        disabled={isLoading}
                      >
                        {isLoading ? (
                          <img
                            src={loadingIcon}
                            alt="Loading"
                            className={`${styles.versionIcon} ${styles.spinning}`}
                          />
                        ) : (
                          <img
                            src={chevronIcon}
                            alt="Next"
                            className={`${styles.versionIcon} ${styles.chevronRight}`}
                          />
                        )}
                        {tooltipStates[`next-${message.id}`] && !isLoading && (
                          <div className={styles.tooltip}>Next</div>
                        )}
                      </button>
                    </div>
                  );
                } else {
                  return (
                    <div className={styles.versionControls}>
                      <span className={styles.versionIndicator}>
                        {versionInfo.current}/{versionInfo.total}
                      </span>
                    </div>
                  );
                }
              } else if (
                !isActiveTabShared &&
                message.responseType !== "error"
              ) {
                // SHOW restore button if NOT shared view and NOT error
                const buttonKey = `restore-${message.id}`;
                const isLoading = loadingButtons[buttonKey];

                return (
                  <button
                    className={styles.actionButton}
                    onClick={handleRestoreClick}
                    onMouseEnter={() => {
                      if (!loadingButtons[`restore-${message.id}`]) {
                        handleTooltipShow(`restore-${message.id}`);
                      }
                    }}
                    onMouseLeave={() => {
                      handleTooltipHide(`restore-${message.id}`);
                    }}
                    disabled={
                      isLoading ||
                      isAnyButtonLoading ||
                      loadingButtons[`restore-${message.id}`]
                    } // ADD THIS CHECK
                  >
                    {loadingButtons[`restore-${message.id}`] ? (
                      <>
                        <img
                          src={loadingIcon}
                          alt="Branching"
                          className={`${styles.actionIcon} ${styles.spinning}`}
                        />
                        <span className={styles.loadingLabel}>Branching</span>
                      </>
                    ) : (
                      <img
                        src={restoreIcon}
                        alt="Branch"
                        className={styles.actionIcon}
                      />
                    )}
                    {tooltipStates[`restore-${message.id}`] &&
                      !loadingButtons[`restore-${message.id}`] && (
                        <div className={styles.tooltip}>Branch</div>
                      )}
                  </button>
                );
              }
              return null;
            })()}
          </div>
        )}
      </>
    );
  },
);

class NoahClient {
  private baseUrl: string = BACKEND_URL;

  private abortController: AbortController | null = null;
  private requestQueue: Array<() => Promise<any>> = [];
  private isProcessing: boolean = false;

  private async processQueue(): Promise<void> {
    if (this.isProcessing || this.requestQueue.length === 0) {
      return;
    }

    this.isProcessing = true;

    while (this.requestQueue.length > 0) {
      const request = this.requestQueue.shift();
      if (request) {
        try {
          await request();
        } catch (error) {
          // console.error("Queued request failed:", error);
        }
        // Add delay between requests to prevent overwhelming backend
        await new Promise((resolve) => setTimeout(resolve, 100));
      }
    }

    this.isProcessing = false;
  }

  private queueRequest<T>(requestFn: () => Promise<T>): Promise<T> {
    return new Promise((resolve, reject) => {
      this.requestQueue.push(async () => {
        try {
          const result = await requestFn();
          resolve(result);
        } catch (error) {
          reject(error);
        }
      });
      this.processQueue();
    });
  }

  async executeCommand(
    userInput: string,
    selectionContext: any,
    branchId?: string,
  ): Promise<any> {
    return this.queueRequest(async () => {
      try {
        this.abortController = new AbortController();

        const response = await fetch(`${this.baseUrl}/api/command`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            user_input: userInput,
            context: {
              selection: selectionContext.selection || [],
              objects: selectionContext.objects || [],
              history: selectionContext.history || [],
              last_created: selectionContext.last_created || "",
            },
            branch_id: branchId,
          }),
          signal: this.abortController.signal,
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data;
      } catch (error) {
        if (error instanceof Error && error.name === "AbortError") {
          throw new Error("Request was cancelled");
        }

        if (error instanceof Error && error.message.includes("timed out")) {
          throw new Error("Operation timed out - please try again");
        }

        throw error;
      }
    });
  }

  cancelCurrentRequest() {
    if (this.abortController) {
      this.abortController.abort();
      this.abortController = null;
    }
    // Clear the queue of pending requests
    this.requestQueue = [];
    this.isProcessing = false;
  }

  async checkHealth(): Promise<boolean> {
    try {
      const response = await fetch(`${this.baseUrl}/health`, {
        method: "GET",
        signal: AbortSignal.timeout(30000),
      });
      return response.ok;
    } catch (error) {
      return false;
    }
  }
}

const fetchAIResponse = async (
  operationType: "create" | "modify" | "delete",
  featureName: string,
  userInput: string,
): Promise<string> => {
  const startTime = Date.now();
  // console.log(`🤖 Fetching AI response for: ${operationType} - ${featureName}`);

  try {
    const response = await fetch(`${BACKEND_URL}/api/generate-response`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        operation_type: operationType,
        feature_name: featureName,
        user_input: userInput,
      }),
      signal: AbortSignal.timeout(300000),
    });

    const elapsed = Date.now() - startTime;
    // console.log(`🤖 AI response received in ${elapsed}ms`);

    if (!response.ok) {
      throw new Error("Failed to generate response");
    }

    const data = await response.json();
    // console.log(`🤖 FULL AI response:`, data);
    // console.log(`🤖 AI response text: ${data.response}`);
    return data.response || "Done! Let me know what's next.";
  } catch (error) {
    const elapsed = Date.now() - startTime;
    // console.warn(`🤖 AI response fetch failed after ${elapsed}ms:`, error);
    const fallbacks = {
      create: "Done! Let me know what's next.",
      modify: "Changes applied. Anything else?",
      delete: "Removed. Need anything else?",
    };
    return fallbacks[operationType] || fallbacks.create;
  }
};

// Add this to the RightSidebarRefMethods interface in RightSidebar.tsx
interface RightSidebarRefMethods {
  updateChatMessages: (
    currentDisplayName: string,
    newDisplayName: string,
  ) => void;
  clearChat: () => void;
  setChatMessages: (messages: ChatMessage[]) => void;
  getChatMessages?: () => ChatMessage[]; // Make sure this exists
  sendInitialPrompt: (prompt: string) => void;
  focusInput: () => void;
}

const checkAndConsumeCredits = async (
  userRef: any,
  userProfile: any,
  userUid: string,
): Promise<{ allowed: boolean; reason?: string }> => {
  if (!userProfile) return { allowed: false, reason: "No profile" };

  const tier = userProfile.subscriptionTier || "free";

  // 1. PRO & ENTERPRISE: Unlimited (BYPASS EVERYTHING)
  if (tier === "pro" || tier === "enterprise") {
    return { allowed: true };
  }

  const now = Date.now();
  const ONE_DAY_MS = 24 * 60 * 60 * 1000;
  const ONE_MONTH_MS = 30 * 24 * 60 * 60 * 1000;

  // --- LOGIC: RESET DAILY CREDITS ---
  // If last reset was > 24 hours ago, we consider them having 5 fresh credits
  let dailyCredits = userProfile.dailyCredits ?? 0;
  const lastDailyReset = userProfile.lastDailyReset?.toMillis?.() || 0;
  const isDailyStale = now - lastDailyReset > ONE_DAY_MS;

  if (isDailyStale) {
    dailyCredits = 5; // Reset to 5
  }

  // --- LOGIC: RESET MONTHLY CAP ---
  let monthlyUsed = userProfile.monthlyFreeCreditsUsed ?? 0;
  const lastMonthlyReset = userProfile.lastMonthlyReset?.toMillis?.() || 0;
  const isMonthlyStale = now - lastMonthlyReset > ONE_MONTH_MS;

  if (isMonthlyStale) {
    monthlyUsed = 0; // Reset monthly usage counter
  }

  // Define Monthly Cap for Daily Credits
  const MONTHLY_FREE_CAP = tier === "hobbyist" ? 150 : 30;

  // --- ATTEMPT 1: USE DAILY CREDITS ---
  // Condition: Must have daily credits AND not exceeded monthly cap
  if (dailyCredits > 0 && monthlyUsed < MONTHLY_FREE_CAP) {
    // We update Firestore directly here
    try {
      await updateDoc(userRef, {
        dailyCredits: dailyCredits - 1,
        monthlyFreeCreditsUsed: monthlyUsed + 1,
        // Only update timestamps if they were stale (to start the new period)
        ...(isDailyStale ? { lastDailyReset: new Date() } : {}),
        ...(isMonthlyStale ? { lastMonthlyReset: new Date() } : {}),
      });
      // 🔧 ADD THIS: Update the global userProfile state so Toolbar sees it
      if (userProfile) {
        userProfile.dailyCredits = dailyCredits - 1;
        userProfile.monthlyFreeCreditsUsed = monthlyUsed + 1;
      }

      return { allowed: true };
    } catch (e) {
      console.error("Failed to consume daily credit:", e);
      return { allowed: false, reason: "Error consuming credit" };
    }
  }

  // --- ATTEMPT 2: USE ROLLOVER CREDITS ---
  // If Daily failed (empty or cap reached), check rollover bank
  const rolloverCredits = userProfile.credits || 0;

  if (rolloverCredits > 0) {
    try {
      await updateDoc(userRef, {
        credits: rolloverCredits - 1,
        // Still perform maintenance on stale timestamps to keep data healthy
        ...(isDailyStale
          ? { lastDailyReset: new Date(), dailyCredits: 5 }
          : {}),
        ...(isMonthlyStale
          ? { lastMonthlyReset: new Date(), monthlyFreeCreditsUsed: 0 }
          : {}),
      });
      return { allowed: true };
    } catch (e) {
      console.error("Failed to consume rollover credit:", e);
      return { allowed: false, reason: "Error consuming credit" };
    }
  }

  // Out of credits
  return { allowed: false, reason: "out_of_credits" };
};

const CornerLines = ({
  inputAreaRef,
}: {
  inputAreaRef: React.RefObject<HTMLDivElement>;
}) => {
  const [lines, setLines] = React.useState<
    Array<{
      width: number;
      left: number;
      top: number;
      angle: number;
    }>
  >([]);
  const rafRef = React.useRef<number>();

  React.useEffect(() => {
    const updateLines = () => {
      // Cancel any pending update
      if (rafRef.current) {
        cancelAnimationFrame(rafRef.current);
      }

      rafRef.current = requestAnimationFrame(() => {
        if (!inputAreaRef.current) return;

        const inputRect = inputAreaRef.current.getBoundingClientRect();
        const sidebar = document.querySelector('[class*="sidebar"]');
        if (!sidebar) return;

        const sidebarRect = sidebar.getBoundingClientRect();

        const offset = -1;

        const inputTopLeft = {
          x: inputRect.left - offset - 0.5,
          y: inputRect.top - offset,
        };

        const inputTopRight = {
          x: inputRect.right + offset,
          y: inputRect.top - offset - 0.5,
        };

        const inputBottomLeft = {
          x: inputRect.left - offset,
          y: inputRect.bottom + offset + 0.5,
        };

        const inputBottomRight = {
          x: inputRect.right + offset + 0.5,
          y: inputRect.bottom + offset,
        };

        const targets = {
          topLeft: { x: sidebarRect.left, y: sidebarRect.top },
          topRight: { x: window.innerWidth, y: 0 },
          bottomLeft: { x: sidebarRect.left, y: window.innerHeight },
          bottomRight: { x: window.innerWidth, y: window.innerHeight },
        };

        const createLine = (
          from: { x: number; y: number },
          to: { x: number; y: number },
        ) => {
          const dx = to.x - from.x;
          const dy = to.y - from.y;
          const width = Math.sqrt(dx * dx + dy * dy);
          const angle = Math.atan2(dy, dx) * (180 / Math.PI);
          return { width, left: from.x, top: from.y, angle };
        };

        setLines([
          createLine(inputTopLeft, targets.topLeft),
          createLine(inputTopRight, targets.topRight),
          createLine(inputBottomLeft, targets.bottomLeft),
          createLine(inputBottomRight, targets.bottomRight),
        ]);
      });
    };

    updateLines();

    window.addEventListener("resize", updateLines);
    window.addEventListener("scroll", updateLines, true);

    const resizeObserver = new ResizeObserver(updateLines);
    const mutationObserver = new MutationObserver(updateLines);

    if (inputAreaRef.current) {
      resizeObserver.observe(inputAreaRef.current);

      // Observe the inputArea for any DOM changes
      mutationObserver.observe(inputAreaRef.current, {
        attributes: true,
        childList: true,
        subtree: true,
        attributeFilter: ["style", "class"],
      });

      // Also observe the textarea specifically
      const textarea = inputAreaRef.current.querySelector("textarea");
      if (textarea) {
        resizeObserver.observe(textarea);
        mutationObserver.observe(textarea, {
          attributes: true,
          attributeFilter: ["style"],
        });
      }
    }

    const sidebar = document.querySelector('[class*="sidebar"]');
    if (sidebar) {
      resizeObserver.observe(sidebar);
      mutationObserver.observe(sidebar, {
        attributes: true,
        attributeFilter: ["class", "style"],
      });
    }

    return () => {
      if (rafRef.current) {
        cancelAnimationFrame(rafRef.current);
      }
      window.removeEventListener("resize", updateLines);
      window.removeEventListener("scroll", updateLines, true);
      resizeObserver.disconnect();
      mutationObserver.disconnect();
    };
  }, [inputAreaRef]);

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        pointerEvents: "none",
        zIndex: 1,
      }}
    >
      {lines.map((line, index) => (
        <div
          key={index}
          style={{
            position: "absolute",
            width: `${line.width}px`,
            height: "1px",
            backgroundColor: "var(--color-border)",
            left: `${line.left}px`,
            top: `${line.top}px`,
            transform: `rotate(${line.angle}deg)`,
            transformOrigin: "0 0",
            willChange: "transform, width",
          }}
        />
      ))}
    </div>
  );
};

const RightSidebar = React.forwardRef<
  RightSidebarRefMethods,
  RightSidebarProps
>(
  (
    {
      onDockToggle,
      currentSelection = [],
      projectId,
      onSelectionClear,
      onProjectCreated,
      onShapeCreated,
      onSuccessfulOperation,
      activeModelId,
      onCommandStart,
      onCommandEnd,
      onFeatureCreated,
      onProcessUserInput,
      onProcessAIResponse,
      onRestoreToOperation,
      onNavigateOperationVersion,
      getOperationVersionInfo,
      isInVersionMode,
      getVersionedOperations,
      onChatMessagesChange,
      currentBranch = "main",
      onBranchChange,
      openModels, // ← ADD THIS LINE
      onTabRename, // ← ADD THIS LINE
      onShowCreditsModal,
      isModelLoading = false,
      isSharedView = false,
      isActiveTabShared = false,
      noahGeometry = [],
      isPendingSave = false,
      featureTree = [],
      onLoadingChange,
      currentMeasurement,
      onButtonLoadingChange,
      selectedUnit = "mm", // ← ADD THIS LINE WITH DEFAULT
      onInitialCreationError,
      onUnitChange, // ← This was already there
      isProjectPublic = false,
      projectShareToken,
      onShareStatusChange,
    },
    ref,
  ) => {
    const [mentionMenuPosition, setMentionMenuPosition] = useState({
      top: 0,
      left: 0,
      width: 0,
    });
    const [isTextWrapped, setIsTextWrapped] = useState(false);
    const layoutChangeTimeoutRef = useRef<NodeJS.Timeout | null>(null);

    const inputWrapperRef = useRef<HTMLDivElement>(null);
    const inputAreaRef = useRef<HTMLDivElement>(null);

    const [isScrolled, setIsScrolled] = useState(false);
    const { getIcon } = useThemedIcon();
    const sendIcon = getIcon(sendIconLight, sendIconDark);
    const sendIconDisabled = getIcon(
      sendIconDisabledLight,
      sendIconDisabledDark,
    );
    const [isShareDropdownOpen, setIsShareDropdownOpen] = useState(false);
    const [isCopiedShare, setIsCopiedShare] = useState(false);
    const [localIsPublic, setLocalIsPublic] = useState(false);
    const [localShareToken, setLocalShareToken] = useState<string | undefined>(
      undefined,
    );
    const shareDropdownRef = useRef<HTMLDivElement>(null);
    const shareDropdownShouldStayOpen = useRef(false);
    const privateIconDefault = getIcon(privateIconLight, privateIconDark);
    const publicIconDefault = getIcon(publicIconLight, publicIconDark);
    const privateIconHover = getIcon(privateIconBlack, privateIconWhite);
    const publicIconHover = getIcon(publicIconBlack, publicIconWhite);
    const copyIconShare = getIcon(copyIconLight, copyIconDark);
    const checkIconShare = getIcon(
      checkMessagesIconLight,
      checkMessagesIconDark,
    );
    const [selectedModel, setSelectedModel] = useState("gemini-3-pro-preview");
    const [showModelMenu, setShowModelMenu] = useState(false);
    const [isModelButtonHovered, setIsModelButtonHovered] = useState(false);
    const modelDropdownRef = useRef<HTMLDivElement>(null);
    const modelButtonRef = useRef<HTMLButtonElement>(null);
    const [isEditingFileName, setIsEditingFileName] = useState(false);
    const editableFileNameRef = useRef<HTMLSpanElement | null>(null);
    const [isUnitButtonHovered, setIsUnitButtonHovered] = useState(false);
    const [showUnitMenu, setShowUnitMenu] = useState(false);
    const sendIconReversed = getIcon(sendIconDark, sendIconLight); // Swapped order
    const inputTextareaRef = useRef<HTMLTextAreaElement>(null);
    const [showMentionMenu, setShowMentionMenu] = useState(false);
    const [mentionFilter, setMentionFilter] = useState("");
    const [mentionStartIndex, setMentionStartIndex] = useState<number | null>(
      null,
    );
    const isTextWrappedRef = useRef(false);
    const [textareaHeight, setTextareaHeight] = useState(32); // 3rem = 48px
    const [selectedMentionIndex, setSelectedMentionIndex] = useState(0);
    const [isHeaderScrolled, setIsHeaderScrolled] = useState(false);

    const [edgeMeasurement, setEdgeMeasurement] = useState<number | null>(
      currentMeasurement || null,
    );
    const unitButtonRef = useRef<HTMLButtonElement>(null);
    const [errorMessage, setErrorMessage] = useState<{
      message: string;
      type: "general" | "credits";
    } | null>(null);
    const warningIcon = getIcon(warningIconLight, warningIconDark);
    const mentionIcon = getIcon(mentionIconLight, mentionIconDark);
    const mentionActiveIcon = getIcon(
      mentionActiveIconLight,
      mentionActiveIconDark,
    );
    const unitIcon = getIcon(unitIconLight, unitIconDark);
    const unitIconActive = getIcon(unitIconActiveLight, unitIconActiveDark);
    const closeIcon = getIcon(closeIconLight, closeIconDark);
    const selectedActiveIcon = getIcon(
      selectedActiveIconLight,
      selectedActiveIconDark,
    );
    // Add this effect near the top of RightSidebar component

    const isMac = navigator.platform.toUpperCase().indexOf("MAC") >= 0;
    const shortcutKey = isMac ? "⌘K" : "Ctrl+K";
    const mentionMenuRef = useRef<HTMLDivElement>(null);
    const dockToRightIcon = getIcon(dockToRightIconLight, dockToRightIconDark);
    const glossaryIcon = getIcon(glossaryIconLight, glossaryIconDark);
    const brainIcon = getIcon(brainIconLight, brainIconDark);
    const gptIcon = getIcon(gptIconLight, gptIconDark);
    const aiModels = [
      {
        value: "gemini-3-pro-preview",
        label: "Gemini 3 Pro",
        provider: "Latest Google model with excellent multi-modal capabilities",
        icon: (
          <img src={geminiIcon} alt="Gemini" className={styles.modelIcon} />
        ),
      },
      {
        value: "claude-opus-4-6",
        label: "Claude Opus 4.6",
        provider: "Most powerful Anthropic model for complex reasoning",
        icon: (
          <img src={claudeIcon} alt="Claude" className={styles.modelIcon} />
        ),
      },
      {
        value: "gpt-5.2",
        label: "GPT-5.2",
        provider: "Most powerful OpenAI model with adaptive reasoning",
        icon: <img src={gptIcon} alt="GPT" className={styles.modelIcon} />,
      },
    ];
    const loadingIcon = getIcon(loadingIconLight, loadingIconDark);
    const createIcon = getIcon(createIconLight, createIconDark);
    const modifyIcon = getIcon(modifyIconLight, modifyIconDark);
    const deleteIcon = getIcon(deleteIconLight, deleteIconDark);

    const restoreIcon = getIcon(restoreIconLight, restoreIconDark);
    const thumbsDownIcon = getIcon(thumbsDownIconLight, thumbsDownIconDark);
    const thumbsDownFillIcon = getIcon(thumbsDownFillLight, thumbsDownFillDark);
    const thumbsUpIcon = getIcon(thumbsUpIconLight, thumbsUpIconDark);
    const thumbsUpFillIcon = getIcon(
      thumbsUpFillIconLight,
      thumbsUpFillIconDark,
    );
    const selectionIcon = getIcon(selectionIconLight, selectionIconDark);
    const sessionHeartbeatRef = useRef<NodeJS.Timeout | null>(null);
    const thinkingStartTimeRef = useRef<number | null>(null);
    const shouldAutoScrollRef = useRef(true);

    const copyIcon = getIcon(copyIconLight, copyIconDark);
    const checkIcon = getIcon(checkIconLight, checkIconDark);
    const chevronIcon = getIcon(chevronIconLight, chevronIconDark);
    const chevronActiveIcon = getIcon(
      chevronActiveIconLight,
      chevronActiveIconDark,
    );
    const arkIcon = getIcon(arkIconLight, arkIconDark);
    // Add this custom hook after the imports, before the RightSidebar component
    const useTypingPlaceholder = (phrases: string[], isActive: boolean) => {
      const [currentText, setCurrentText] = useState("");
      const [currentPhraseIndex, setCurrentPhraseIndex] = useState(0);
      const [isTyping, setIsTyping] = useState(true);
      const [isPaused, setIsPaused] = useState(false);

      useEffect(() => {
        if (!isActive) {
          setCurrentText("");
          return;
        }

        const currentPhrase = phrases[currentPhraseIndex];

        if (isPaused) {
          const pauseTimer = setTimeout(() => {
            setIsPaused(false);
            setIsTyping(false);
          }, 2000); // Pause for 2 seconds after typing completes
          return () => clearTimeout(pauseTimer);
        }

        if (isTyping) {
          if (currentText.length < currentPhrase.length) {
            const typingTimer = setTimeout(() => {
              setCurrentText(currentPhrase.slice(0, currentText.length + 1));
            }, 50); // Typing speed
            return () => clearTimeout(typingTimer);
          } else {
            setIsPaused(true);
          }
        } else {
          if (currentText.length > 0) {
            const deletingTimer = setTimeout(() => {
              setCurrentText(currentText.slice(0, -1));
            }, 30); // Deleting speed (faster)
            return () => clearTimeout(deletingTimer);
          } else {
            setCurrentPhraseIndex((prev) => (prev + 1) % phrases.length);
            setIsTyping(true);
          }
        }
      }, [
        currentText,
        currentPhraseIndex,
        isTyping,
        isPaused,
        phrases,
        isActive,
      ]);

      return currentText;
    };

    const [isContentScrolled, setIsContentScrolled] = useState(false);
    const [inputValue, setInputValue] = useState("");

    const handleFileNameEdit = () => {
      setIsEditingFileName(true);
      setTimeout(() => {
        const element = editableFileNameRef.current;
        if (element) {
          element.focus();
          const range = document.createRange();
          const sel = window.getSelection();
          range.selectNodeContents(element);
          sel?.removeAllRanges();
          sel?.addRange(range);
        }
      }, 0);
    };

    const handleFileNameKeyDown = (event: React.KeyboardEvent) => {
      if (event.key === "Enter") {
        event.preventDefault();
        const element = editableFileNameRef.current;
        if (element) {
          handleFileNameSave(element.textContent || "");
        }
      } else if (event.key === "Escape") {
        // ✅ FIX: Manually revert text on Escape
        if (editableFileNameRef.current && activeModelId) {
          const currentTab = openModels?.find((m) => m.id === activeModelId);
          if (currentTab) {
            editableFileNameRef.current.textContent = currentTab.name;
          }
        }
        setIsEditingFileName(false);
      }
    };

    const handleFileNameBlur = () => {
      const element = editableFileNameRef.current;
      if (element) {
        handleFileNameSave(element.textContent || "");
      }
    };

    const handleFileNameSave = (newName: string) => {
      if (!newName || newName.trim() === "") {
        // ✅ FIX: Manually revert text if empty (invalid)
        // This forces the span to show the original name again immediately
        if (editableFileNameRef.current && activeModelId) {
          const currentTab = openModels?.find((m) => m.id === activeModelId);
          if (currentTab) {
            editableFileNameRef.current.textContent = currentTab.name;
          }
        }
        setIsEditingFileName(false);
        return;
      }

      if (activeModelId && onTabRename) {
        onTabRename(activeModelId, newName.trim());

        // Trigger TopToolbar to refresh its project list
        setTimeout(() => {
          if ((window as any).__refreshTopToolbarProjects) {
            (window as any).__refreshTopToolbarProjects();
          }
        }, 100);
      }
      setIsEditingFileName(false);
    };

    // Expose openModels to header for file name display
    useEffect(() => {
      (window as any).__openModels = openModels;
    }, [openModels]);

    const generateShareToken = () => {
      return (
        Math.random().toString(36).substring(2, 15) +
        Math.random().toString(36).substring(2, 15)
      );
    };

    const handleSharePrivateClick = async () => {
      if (!projectId) return;
      shareDropdownShouldStayOpen.current = true;
      try {
        await updateDoc(doc(db, "projects", projectId), {
          isPublic: false,
          // ❌ REMOVE THIS LINE: updatedAt: new Date(),
        });
        setLocalIsPublic(false);
        if (onShareStatusChange) {
          onShareStatusChange();
        }
      } catch (error) {
        console.error("Error setting project to private:", error);
      }
    };

    const handleSharePublicClick = async () => {
      if (!projectId) return;
      shareDropdownShouldStayOpen.current = true;
      try {
        let token = localShareToken;
        if (!token) {
          token = generateShareToken();
          setLocalShareToken(token);
        }
        await updateDoc(doc(db, "projects", projectId), {
          isPublic: true,
          shareToken: token,
          // ❌ REMOVE THIS LINE: updatedAt: new Date(),
        });
        setLocalIsPublic(true);

        const shareUrl = `${window.location.origin}/share/${token}`;
        navigator.clipboard.writeText(shareUrl);
        setIsCopiedShare(true);
        setTimeout(() => {
          setIsCopiedShare(false);
        }, 2000);

        if (onShareStatusChange) {
          onShareStatusChange();
        }
      } catch (error) {
        console.error("Error setting project to public:", error);
      }
    };

    const handleCopyShareLink = () => {
      if (localShareToken) {
        const shareUrl = `${window.location.origin}/share/${localShareToken}`;
        navigator.clipboard.writeText(shareUrl);
        setIsCopiedShare(true);
        setTimeout(() => {
          setIsCopiedShare(false);
        }, 2000);
      }
    };

    const formatThinkingDuration = (ms: number): string => {
      const totalSeconds = Math.floor(ms / 1000);
      const minutes = Math.floor(totalSeconds / 60);
      const seconds = totalSeconds % 60;

      if (minutes === 0) {
        return `${seconds}s`;
      } else if (seconds === 0) {
        return minutes === 1 ? "1min" : `${minutes}mins`;
      } else {
        return `${minutes}min, ${seconds}s`;
      }
    };

    const parseFeatures = (featureName: string): string[] => {
      if (!featureName) return [];
      return featureName
        .split(",")
        .map((f) => f.trim())
        .filter((f) => f.length > 0);
    };

    // Add this helper function after the state declarations (around line 550)
    const getFlattenedFeatures = useMemo(() => {
      const features: Array<{
        id: string;
        name: string;
        displayName: string;
        type: string;
      }> = [];

      const operationMapping: { [key: string]: string } = {
        Pad: "Extrude",
        Pocket: "Cut",
        Thickness: "Shell",
      };

      const getDisplayNameForFeature = (technicalName: string): string => {
        for (const [techTerm, displayTerm] of Object.entries(
          operationMapping,
        )) {
          const regex = new RegExp(`^${techTerm}(\\d{3})$`);
          const match = technicalName.match(regex);
          if (match) {
            return `${displayTerm}${match[1]}`;
          }
        }
        return technicalName;
      };

      const processItem = (item: TreeItem) => {
        const displayName =
          item.displayName || getDisplayNameForFeature(item.name);
        features.push({
          id: item.id,
          name: item.name,
          displayName: displayName,
          type: item.type,
        });

        if (item.children) {
          item.children.forEach(processItem);
        }
      };

      featureTree.forEach(processItem);
      return features;
    }, [featureTree]);

    const filteredMentions = useMemo(() => {
      if (!mentionFilter) return getFlattenedFeatures;

      const filterLower = mentionFilter.toLowerCase().trim();
      return getFlattenedFeatures.filter((feature) =>
        feature.displayName.toLowerCase().includes(filterLower),
      );
    }, [getFlattenedFeatures, mentionFilter]);

    // Close mention menu when clicking outside
    // Close unit menu when clicking outside
    const unitDropdownRef = useRef<HTMLDivElement>(null); // ← ADD THIS at the top with other refs

    // Then update the useEffect:
    useEffect(() => {
      const handleClickOutside = (event: MouseEvent) => {
        // Unit menu logic
        if (
          unitDropdownRef.current &&
          !unitDropdownRef.current.contains(event.target as Node) &&
          unitButtonRef.current &&
          !unitButtonRef.current.contains(event.target as Node)
        ) {
          setShowUnitMenu(false);
        }

        // --- NEW: Model menu logic ---
        if (
          modelDropdownRef.current &&
          !modelDropdownRef.current.contains(event.target as Node) &&
          modelButtonRef.current &&
          !modelButtonRef.current.contains(event.target as Node)
        ) {
          setShowModelMenu(false);
        }
      };

      if (showUnitMenu || showModelMenu) {
        // Added showModelMenu
        document.addEventListener("mousedown", handleClickOutside);
      }

      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [showUnitMenu, showModelMenu]);

    // Listen for edge measurements from View.tsx
    useEffect(() => {
      const handleEdgeMeasurement = (event: CustomEvent) => {
        const measurement = event.detail.length; // Assumed to be in mm
        setEdgeMeasurement(measurement);
      };

      window.addEventListener(
        "edgeMeasurement" as any,
        handleEdgeMeasurement as any,
      );

      return () => {
        window.removeEventListener(
          "edgeMeasurement" as any,
          handleEdgeMeasurement as any,
        );
      };
    }, []);

    // Replace the onChange handler in the input element and add this function (around line 1850)
    // Replace the onChange handler
    const handleInputChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
      const newValue = e.target.value;
      const cursorPos = e.target.selectionStart || 0;

      setInputValue(newValue);

      const textBeforeCursor = newValue.substring(0, cursorPos);
      const lastAtIndex = textBeforeCursor.lastIndexOf("@");

      if (lastAtIndex !== -1) {
        const charBeforeAt =
          lastAtIndex > 0 ? textBeforeCursor[lastAtIndex - 1] : " ";
        // FIX: Check for space OR newline OR start of input
        if (
          charBeforeAt === " " ||
          charBeforeAt === "\n" ||
          lastAtIndex === 0
        ) {
          const textAfterAt = textBeforeCursor.substring(lastAtIndex + 1);
          if (!textAfterAt.includes(" ") && !textAfterAt.includes("\n")) {
            setShowMentionMenu(true);
            setMentionStartIndex(lastAtIndex);
            setMentionFilter(textAfterAt.trim());
            setSelectedMentionIndex(0);
            return;
          }
        }
      }

      setShowMentionMenu(false);
      setMentionStartIndex(null);
      setMentionFilter("");
    };

    // Add this function after handleInputChange
    const handleMentionSelect = (feature: {
      id: string;
      name: string;
      displayName: string;
    }) => {
      if (mentionStartIndex === null) return;

      const beforeMention = inputValue.substring(0, mentionStartIndex);
      const afterMention = inputValue.substring(
        mentionStartIndex + 1 + mentionFilter.length,
      );

      const newValue = `${beforeMention}${feature.displayName}${afterMention}`;
      setInputValue(newValue);
      setShowMentionMenu(false);
      setMentionStartIndex(null);
      setMentionFilter("");

      // Focus back on input
      textareaRef.current?.focus();
    };

    // CRITICAL: Expose input value globally for ProjectLeftSidebar to access
    useEffect(() => {
      (window as any).__currentInputValue = inputValue;
    }, [inputValue]);
    const [isLoading, setIsLoading] = useState(false);
    // CRITICAL: Expose current selection globally for ProjectLeftSidebar to access

    const [loadingButtons, setLoadingButtons] = useState<{
      [key: string]: boolean;
    }>({});

    // Expose function to clear branch button loading state
    useEffect(() => {
      (window as any).__clearBranchButtonLoading = () => {
        setLoadingButtons((prev) => {
          const cleared: { [key: string]: boolean } = {};
          Object.keys(prev).forEach((key) => {
            if (!key.startsWith("restore-")) {
              cleared[key] = prev[key];
            }
          });
          return cleared;
        });
      };

      return () => {
        delete (window as any).__clearBranchButtonLoading;
      };
    }, []);

    const [currentUserInput, setCurrentUserInput] = useState<string>("");
    const loadingMessage = useLoadingSequence(isLoading, currentUserInput);
    const stopIcon = getIcon(stopIconLight, stopIconDark);

    const [chatMessages, setChatMessages] = useState<ChatMessage[]>([]);
    // ============ ADD THIS ENTIRE SECTION HERE ============
    // Preserve loading button states across chat message updates
    const loadingButtonsRef = useRef<{ [key: string]: boolean }>({});

    useEffect(() => {
      const chatMessagesElement = chatMessagesRef.current;
      if (!chatMessagesElement) return;

      const handleScroll = () => {
        const scrollTop = chatMessagesElement.scrollTop;

        // Show header border when scrolled down from top
        setIsHeaderScrolled(scrollTop > 0);
      };

      chatMessagesElement.addEventListener("scroll", handleScroll);

      // Check initial scroll position
      handleScroll();

      return () => {
        chatMessagesElement.removeEventListener("scroll", handleScroll);
      };
    }, [chatMessages.length]);

    useEffect(() => {
      // Sync ref with state
      loadingButtonsRef.current = loadingButtons;
    }, [loadingButtons]);

    useEffect(() => {
      // When chat messages update, restore any active loading states
      if (Object.keys(loadingButtonsRef.current).length > 0) {
        const activeLoadingStates = Object.entries(loadingButtonsRef.current)
          .filter(([_, isLoading]) => isLoading)
          .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});

        if (Object.keys(activeLoadingStates).length > 0) {
          setLoadingButtons((prev) => ({ ...prev, ...activeLoadingStates }));
        }
      }
    }, [chatMessages]);
    // ============ END OF ADDITION ============

    const [connectionStatus, setConnectionStatus] = useState<
      "unknown" | "connected" | "error"
    >("unknown");
    const [typingText, setTypingText] = useState("");
    const [currentTypingMessageId, setCurrentTypingMessageId] = useState<
      number | null
    >(null);
    const [tooltipStates, setTooltipStates] = useState<{
      [key: string]: boolean;
    }>({});
    const [copiedMessageStates, setCopiedMessageStates] = useState<{
      [key: number]: boolean;
    }>({});
    const [thumbsStates, setThumbsStates] = useState<{
      [key: number]: { up: boolean; down: boolean };
    }>({});
    const [isUserGuideOpen, setIsUserGuideOpen] = useState(false);

    const [showTooltip, setShowTooltip] = useState(false);
    const textareaRef = useRef<HTMLInputElement>(null);
    const chatMessagesRef = useRef<HTMLDivElement>(null);
    const noahClientRef = useRef(new NoahClient());
    const { user, useCredit, userProfile } = useAuth();

    const isAnyButtonLoading = Object.values(loadingButtons).some(
      (loading) => loading,
    );

    useEffect(() => {
      const isLoading = Object.values(loadingButtons).some(
        (loading) => loading,
      );
      onButtonLoadingChange?.(isLoading);
    }, [loadingButtons, onButtonLoadingChange]);

    // Add this effect near the top of RightSidebar component
    useEffect(() => {
      const isLoading = Object.values(loadingButtons).some(
        (loading) => loading,
      );
      onButtonLoadingChange?.(isLoading);
    }, [loadingButtons, onButtonLoadingChange]);

    useEffect(() => {
      if (onChatMessagesChange) {
        onChatMessagesChange(chatMessages);
      }
    }, [chatMessages]); // Remove onChatMessagesChange from dependencies

    const escapeRegex = (str: string): string => {
      return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    };

    const handleTooltipShow = useCallback((tooltipKey: string) => {
      setTooltipStates((prev) => ({ ...prev, [tooltipKey]: true }));
    }, []);

    const handleTooltipHide = useCallback((tooltipKey: string) => {
      setTooltipStates((prev) => ({ ...prev, [tooltipKey]: false }));
    }, []);

    const updateChatMessagesForRename = useCallback(
      (currentDisplayName: string, newDisplayName: string) => {
        // Prevent auto-scroll during rename
        shouldAutoScrollRef.current = false;

        setChatMessages((prevMessages) => {
          let hasUpdates = false;
          const updatedMessages = prevMessages.map((message) => {
            if (message.type === "assistant") {
              const regex = new RegExp(
                `\\b${escapeRegex(currentDisplayName)}\\b`,
                "g",
              );

              const contentMatch = regex.test(message.content);
              const featureNameMatch =
                message.featureName && regex.test(message.featureName);
              const originalContentMatch =
                message.originalContent && regex.test(message.originalContent);

              if (contentMatch || featureNameMatch || originalContentMatch) {
                hasUpdates = true;

                return {
                  ...message,
                  content: message.content.replace(regex, newDisplayName),
                  featureName: message.featureName
                    ? message.featureName.replace(regex, newDisplayName)
                    : undefined,
                  originalContent: message.originalContent
                    ? message.originalContent.replace(regex, newDisplayName)
                    : undefined,
                  id: Date.now() + Math.random(),
                };
              }
            }
            return message;
          });

          if (hasUpdates) {
            return updatedMessages;
          }

          return prevMessages;
        });
      },
      [],
    );

    const clearChat = useCallback(() => {
      setChatMessages([]);
      setTypingText("");
      setCurrentTypingMessageId(null);
      setCopiedMessageStates({});
      setThumbsStates({});
      setTooltipStates({});
      setLoadingButtons({});
    }, []);

    // Also update the React.useImperativeHandle in RightSidebar.tsx:

    const parsedSelection = useMemo(() => {
      if (typeof currentSelection === "string") {
        try {
          const parsed = JSON.parse(currentSelection);
          return Array.isArray(parsed) ? parsed : [];
        } catch (error) {
          return [];
        }
      }

      if (Array.isArray(currentSelection)) {
        return currentSelection;
      }

      return [];
    }, [currentSelection]);

    // Clear measurement when selection is cleared
    useEffect(() => {
      if (parsedSelection.length === 0) {
        setEdgeMeasurement(null);
      }
    }, [parsedSelection]);

    useEffect(() => {
      (window as any).__currentSelection = parsedSelection;
    }, [parsedSelection]);

    useEffect(() => {
      // Expose feature tree globally so parseResponse can check for custom display names
      (window as any).__currentFeatureTree = featureTree;
    }, [featureTree]);

    useEffect(() => {
      const testConnection = async () => {
        try {
          const response = await fetch(`${BACKEND_URL}/health`, {
            method: "GET",
            signal: AbortSignal.timeout(30000),
          });
          if (response.ok) {
            setConnectionStatus("connected");
          } else {
            setConnectionStatus("error");
          }
        } catch (error) {
          // FIXED: Only set to error if it's actually a connection issue
          if (error instanceof Error && !error.message.includes("timeout")) {
            setConnectionStatus("error");
          }
          // For timeouts, keep current status - server might just be busy
        }
      };
      testConnection();
    }, []);

    const buildSelectionContext = async (): Promise<SelectionContext> => {
      // Get REAL document state from backend first
      let realObjects: Array<{ name: string; type: string }> = [];

      try {
        const stateResponse = await fetch(`${BACKEND_URL}/api/command`, {
          method: "POST",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            user_input: "DEBUG_DOCUMENT_STATE",
            context: {},
            branch_id: currentBranch,
          }),
          signal: AbortSignal.timeout(30000),
        });

        if (stateResponse.ok) {
          const stateResult = await stateResponse.json();
          realObjects =
            stateResult.debug_data?.all_objects?.map((obj: any) => ({
              name: obj.name,
              type: obj.type,
            })) || [];

          // console.log(`📋 Real document state: ${realObjects.length} objects`);
        }
      } catch (error) {
        // console.warn("Failed to get document state:", error);
      }

      // Fallback if we couldn't get real state
      if (realObjects.length === 0) {
        realObjects = [{ name: "Document", type: "App::Document" }];
      }

      if (parsedSelection.length === 0) {
        return {
          objects: realObjects, // ✅ USE REAL STATE
          history: [],
          last_created: "",
          selection: [],
        };
      }

      const edgeSelections = parsedSelection.filter(
        (item) => item.type === "edge",
      );
      const faceSelections = parsedSelection.filter(
        (item) => item.type === "face",
      );

      const groupedSelection: any[] = [];

      if (edgeSelections.length > 0) {
        const flattenedCoordinates: number[][] = [];
        edgeSelections.forEach((s) => {
          if (s.browserCoordinates) {
            const flatCoords = Array.isArray(s.browserCoordinates)
              ? s.browserCoordinates.flat()
              : s.browserCoordinates;
            flattenedCoordinates.push(flatCoords);
          }
        });

        groupedSelection.push({
          type: "edges" as const,
          object: edgeSelections[0].object,
          indices: edgeSelections.map((s) => s.index),
          count: edgeSelections.length,
          browser_coordinates: flattenedCoordinates,
        });
      }

      if (faceSelections.length > 0) {
        // ✅ FIX: Send ALL selected faces, not just the first one
        groupedSelection.push({
          type: "faces" as const,
          object: faceSelections[0].object,
          indices: faceSelections.map((s) => s.index), // ✅ ALL indices
          count: faceSelections.length, // ✅ Correct count
          browser_face_data: faceSelections.map((s) => s.browserFaceData), // ✅ ALL face data
        });
      }

      return {
        objects: realObjects, // ✅ USE REAL STATE
        history: [],
        last_created: realObjects[realObjects.length - 1]?.name || "",
        selection: groupedSelection,
      };
    };

    const isGeometryModifyingOperation = (input: string): boolean => {
      const modifyingKeywords = [
        "hole",
        "drill",
        "pocket",
        "cut",
        "subtract",
        "remove",
        "fillet",
        "chamfer",
        "extrude",
        "revolve",
        "sweep",
        "boolean",
        "union",
        "difference",
        "intersection",
        "mirror",
        "pattern",
        "array",
        "shell",
        "thickness",
        "countersink",
        "counterbore",
      ];

      const inputLower = input.toLowerCase();
      return modifyingKeywords.some((keyword) => inputLower.includes(keyword));
    };

    const parseResponse = (
      response: any,
    ): {
      type: "create" | "modify" | "delete" | "error";
      featureName: string;
    } => {
      // console.log("DEBUG Backend Response:", response);

      if (!response?.success) {
        return {
          type: "error",
          featureName: response?.message || "Operation failed",
        };
      }

      const message = response?.message || "";
      const objects = response?.objects || [];

      // NEW: Handle counterbore/countersink with multiple pockets
      if (
        (message.toLowerCase().includes("counterbore") ||
          message.toLowerCase().includes("countersink") ||
          message.toLowerCase().includes("drilled")) &&
        objects.length > 1 &&
        objects.every((o: any) => o?.name?.includes("Pocket"))
      ) {
        // Extract all pocket names and join with "+"
        const pocketNames = objects
          .map((o: any) => o?.name)
          .filter((name: string) => name && name.includes("Pocket"));

        if (pocketNames.length > 1) {
          return {
            type: "modify",
            featureName: pocketNames.join("+"),
          };
        }
      }

      // ADD THIS HELPER FUNCTION RIGHT HERE
      const applyDisplayNameMapping = (technicalName: string): string => {
        const operationMapping: { [key: string]: string } = {
          Pad: "Extrude",
          Pocket: "Cut",
          Thickness: "Shell",
        };

        // 1. Handle standard operation mappings
        for (const [techTerm, displayTerm] of Object.entries(
          operationMapping,
        )) {
          const regex = new RegExp(`^${techTerm}(\\d{3})$`);
          const match = technicalName.match(regex);
          if (match) {
            return `${displayTerm}${match[1]}`;
          }
        }

        // ✅ ADDED: Handle Subtractive Primitives (SubBox001 -> Box001)
        // Matches "Sub" followed by a primitive type and 3 digits
        const subMatch = technicalName.match(
          /^Sub(Box|Cylinder|Sphere|Cone|Torus|Ellipsoid|Prism|Wedge)(\d{3})$/,
        );
        if (subMatch) {
          // Return just the primitive type + number (stripping "Sub")
          return `${subMatch[1]}${subMatch[2]}`;
        }

        return technicalName;
      };

      // REVERSE MAPPING: Display names → Technical names (for user input)
      const reverseDisplayNameMapping = (displayName: string): string => {
        const reverseMapping: { [key: string]: string } = {
          Extrude: "Pad",
          Cut: "Pocket",
          Shell: "Thickness",
        };

        // Check if this matches a display name with number (e.g., "Extrude001")
        for (const [displayTerm, techTerm] of Object.entries(reverseMapping)) {
          const regex = new RegExp(`\\b${displayTerm}(\\d{3})\\b`, "gi"); // Case-insensitive, word boundaries
          displayName = displayName.replace(regex, `${techTerm}$1`);
        }

        return displayName;
      };

      if (message.toLowerCase().includes("deleted")) {
        // Use the actual object name from backend, which includes the number
        const deletedObj =
          objects[0]?.name || message.match(/Deleted (\w+)/)?.[1] || "Feature";

        // APPLY MAPPING TO DELETED OBJECT
        return {
          type: "delete",
          featureName: applyDisplayNameMapping(deletedObj),
        };
      }

      // Check for modify operations FIRST (before create operations)
      // Check for modify operations FIRST (before create operations)
      const isModifyOperation =
        message.toLowerCase().includes("edited") ||
        message.toLowerCase().includes("modified") ||
        message.toLowerCase().includes("fillet") ||
        message.toLowerCase().includes("chamfer") ||
        message.toLowerCase().includes("draft") ||
        message.toLowerCase().includes("thickness") ||
        message.toLowerCase().includes("pad") ||
        message.toLowerCase().includes("pocket") ||
        message.toLowerCase().includes("groove") ||
        message.toLowerCase().includes("drilled") ||
        message.toLowerCase().includes("bored") ||
        message.toLowerCase().includes("rounded") ||
        message.toLowerCase().includes("beveled") ||
        message.toLowerCase().includes("extruded") ||
        message.toLowerCase().includes("revolved") ||
        message.toLowerCase().includes("swept") ||
        message.toLowerCase().includes("patterned") ||
        message.toLowerCase().includes("mirrored") ||
        message.toLowerCase().includes("shelled") ||
        (message.toLowerCase().includes("hole") &&
          objects.some((o: any) => o?.name?.includes("Pocket"))) ||
        (message.toLowerCase().includes("countersink") &&
          objects.some((o: any) => o?.name?.includes("Pocket"))) ||
        (message.toLowerCase().includes("counterbore") &&
          objects.some((o: any) => o?.name?.includes("Pocket")));

      if (isModifyOperation) {
        // Get the feature name from backend
        const backendFeatureName =
          objects.length > 1
            ? objects
                .map((o: any) => o?.name)
                .filter(Boolean)
                .join(", ")
            : objects[0]?.name || "Feature";

        // CRITICAL: Check if this feature already exists in the tree with a custom display name
        // Access the feature tree from the window global (exposed by RightSidebar)
        const featureTree = (window as any).__currentFeatureTree || [];

        const findFeatureDisplayName = (
          tree: any[],
          technicalName: string,
        ): string | null => {
          for (const item of tree) {
            if (item.name === technicalName && item.displayName) {
              return item.displayName;
            }
            if (item.children) {
              for (const child of item.children) {
                if (child.name === technicalName && child.displayName) {
                  return child.displayName;
                }
              }
            }
          }
          return null;
        };

        // Check each object name against the tree
        if (objects.length > 1) {
          const displayNames = objects
            .map((o: any) => {
              const technicalName = o?.name;
              if (!technicalName) return null;

              // First check if it has a custom display name in the tree
              const existingDisplayName = findFeatureDisplayName(
                featureTree,
                technicalName,
              );
              if (existingDisplayName) {
                return existingDisplayName;
              }

              // Otherwise apply standard mapping
              return applyDisplayNameMapping(technicalName);
            })
            .filter(Boolean);

          return { type: "modify", featureName: displayNames.join(", ") };
        } else {
          const technicalName = objects[0]?.name || "Feature";

          // Check if this feature has a custom display name
          const existingDisplayName = findFeatureDisplayName(
            featureTree,
            technicalName,
          );
          if (existingDisplayName) {
            return {
              type: "modify",
              featureName: existingDisplayName,
            };
          }

          // Otherwise apply standard mapping
          return {
            type: "modify",
            featureName: applyDisplayNameMapping(technicalName),
          };
        }
      }

      // Only check for create operations if it's NOT a modify operation
      const isCreateOperation =
        message.toLowerCase().includes("created") ||
        (message.toLowerCase().includes("box") &&
          !message.toLowerCase().includes("pad")) ||
        (message.toLowerCase().includes("cylinder") &&
          !message.toLowerCase().includes("pad")) ||
        (message.toLowerCase().includes("sphere") &&
          !message.toLowerCase().includes("pad")) ||
        message.toLowerCase().includes("cone") ||
        message.toLowerCase().includes("torus") ||
        message.toLowerCase().includes("ellipsoid") ||
        message.toLowerCase().includes("prism") ||
        message.toLowerCase().includes("wedge") ||
        objects.length > 0;

      if (isCreateOperation) {
        // <--- INSERT START: Filter out system objects
        const visibleObjects = objects.filter((o: any) => {
          const name = o?.name || "";
          const type = o?.type || "";

          // Filter out internal system objects
          if (type === "PartDesign::Body" || name === "Body") return false;
          if (type === "App::Origin" || name === "Origin") return false;
          if (type === "App::Line" || name.includes("_Axis")) return false;
          if (type === "App::Plane" || name.includes("_Plane")) return false;
          if (type === "Sketcher::SketchObject" || name.startsWith("Sketch"))
            return false;
          return true;
        });

        // Use filtered list if available, otherwise fallback (e.g. if ONLY a Body was created)
        const objectsToDisplay =
          visibleObjects.length > 0 ? visibleObjects : objects;
        // <--- INSERT END

        if (objectsToDisplay.length > 1) {
          const names = objectsToDisplay
            .map((o: any) => o?.name)
            .filter(Boolean);
          // APPLY MAPPING TO EACH NAME
          const mappedNames = names.map(applyDisplayNameMapping);
          return { type: "create", featureName: mappedNames.join(", ") };
        }

        // Use the EXACT object name from backend, which includes numbers
        // (Fallback to objects[0] if filtering removed everything but we still need to show something)
        const createdObj =
          objectsToDisplay[0]?.name || objects[0]?.name || "Feature";
        // APPLY MAPPING
        return {
          type: "create",
          featureName: applyDisplayNameMapping(createdObj),
        };
      }

      return { type: "create", featureName: "Feature" };
    };

    const handleCopyMessage = useCallback(
      (messageId: number, content: string) => {
        navigator.clipboard.writeText(content);
        setCopiedMessageStates((prev) => ({ ...prev, [messageId]: true }));
        setTimeout(() => {
          setCopiedMessageStates((prev) => ({ ...prev, [messageId]: false }));
        }, 2000);
      },
      [],
    );

    const handleThumbsUp = useCallback((messageId: number) => {
      setThumbsStates((prev) => {
        const currentState = prev[messageId] || { up: false, down: false };
        return {
          ...prev,
          [messageId]: {
            up: !currentState.up,
            down: false,
          },
        };
      });
    }, []);

    const handleThumbsDown = useCallback((messageId: number) => {
      setThumbsStates((prev) => {
        const currentState = prev[messageId] || { up: false, down: false };
        return {
          ...prev,
          [messageId]: {
            up: false,
            down: !currentState.down,
          },
        };
      });
    }, []);

    const debugNoahState = async () => {
      try {
        const response = await fetch(`${BACKEND_URL}/api/command`, {
          method: "POST",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            user_input: "DEBUG_DOCUMENT_STATE",
            context: {},
            branch_id: currentBranch,
          }),
        });

        const result = await response.json();

        // Display debug info in chat
        const debugMessage: ChatMessage = {
          id: Date.now(),
          type: "assistant",
          content: `DEBUG INFO:\n${JSON.stringify(result, null, 2)}`,
          originalContent: "",
          responseType: "create",
        };

        setChatMessages((prev) => [...prev, debugMessage]);
      } catch (error) {
        // console.error("Debug failed:", error);
      }
    };

    const createProjectAndExecute = async (
      userInput: string,
    ): Promise<string> => {
      if (!user) throw new Error("User not authenticated");

      // console.log("🆕 Creating new project for first command...");

      // Step 1: Generate project name
      const q = query(
        collection(db, "projects"),
        where("userId", "==", user.uid),
      );
      const allProjectsSnapshot = await getDocs(q);
      const nonBranchedCount = allProjectsSnapshot.docs.filter((doc) => {
        const data = doc.data();
        return !data.branchedFrom;
      }).length;
      const projectNumber = nonBranchedCount + 1;
      const paddedNumber = projectNumber.toString().padStart(3, "0");
      const projectName = `Untitled${paddedNumber}`;

      // console.log(`📝 Generated name: ${projectName}`);

      // Step 2: Create Firestore document
      const now = new Date();
      const docRef = await addDoc(collection(db, "projects"), {
        name: projectName,
        createdAt: now,
        updatedAt: now,
        userId: user.uid,
        description: "New CAD project",
      });

      // console.log(`✅ Created Firestore document: ${docRef.id}`);

      // Step 3: Setup backend (MATCHING ProjectDashboard exactly)
      // console.log("🔍 Checking backend health...");
      let backendHealthy = false;
      for (let healthCheck = 0; healthCheck < 3; healthCheck++) {
        try {
          const healthResponse = await fetch(`${BACKEND_URL}/health`, {
            signal: AbortSignal.timeout(8000),
          });
          if (healthResponse.ok) {
            backendHealthy = true;
            // console.log("✅ Backend health check passed");
            break;
          }
        } catch (e) {
          console.warn(`⚠️ Health check attempt ${healthCheck + 1}/3 failed`);
          if (healthCheck < 2) {
            await new Promise((resolve) => setTimeout(resolve, 3000));
          }
        }
      }

      if (!backendHealthy) {
        throw new Error(
          "Backend server is not responding. Please try again later.",
        );
      }

      // CRITICAL: Use branch ID WITHOUT timestamp (same as ProjectDashboard)
      const userBranchId = `user_${user.uid}_${docRef.id}`;

      // console.log(`🔥 Setting up backend with branch: ${userBranchId}`);

      // Warmup with command
      // console.log("🔥 Pre-warming sticky session with command...");
      const warmupResponse = await fetch(`${BACKEND_URL}/api/command`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          user_input: "DEBUG_DOCUMENT_STATE",
          context: {},
          branch_id: userBranchId,
        }),
        signal: AbortSignal.timeout(10000),
      });

      if (!warmupResponse.ok) {
        throw new Error("Failed to establish backend session");
      }

      await new Promise((resolve) => setTimeout(resolve, 2000));

      // Verify sticky session
      // console.log("🔍 Verifying sticky session...");
      let stickySessionVerified = false;
      for (let i = 0; i < 3; i++) {
        const verifyStart1 = Date.now();
        const verifyResponse1 = await fetch(`${BACKEND_URL}/api/command`, {
          method: "POST",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            user_input: "DEBUG_DOCUMENT_STATE",
            context: {},
            branch_id: userBranchId,
          }),
          signal: AbortSignal.timeout(10000),
        });
        const verifyTime1 = Date.now() - verifyStart1;

        await new Promise((resolve) => setTimeout(resolve, 100));

        const verifyStart2 = Date.now();
        const verifyResponse2 = await fetch(`${BACKEND_URL}/api/command`, {
          method: "POST",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            user_input: "DEBUG_DOCUMENT_STATE",
            context: {},
            branch_id: userBranchId,
          }),
          signal: AbortSignal.timeout(10000),
        });
        const verifyTime2 = Date.now() - verifyStart2;

        const timeDiff = Math.abs(verifyTime1 - verifyTime2);

        if (timeDiff < 500) {
          // console.log(`✅ Sticky session verified (time diff: ${timeDiff}ms)`);
          stickySessionVerified = true;
          break;
        } else {
          console.warn(
            `⚠️ Sticky session check ${
              i + 1
            }/3 failed (time diff: ${timeDiff}ms)`,
          );
          if (i < 2) {
            await new Promise((resolve) => setTimeout(resolve, 1000));
          }
        }
      }

      if (!stickySessionVerified) {
        throw new Error(
          "Failed to establish sticky session - please try again",
        );
      }

      // Clear document
      // console.log("🧹 Clearing document on new branch...");
      const clearResponse = await fetch(`${BACKEND_URL}/api/command`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          user_input: "CLEAR_DOCUMENT",
          context: {},
          branch_id: userBranchId,
        }),
        signal: AbortSignal.timeout(30000),
      });

      if (!clearResponse.ok) {
        throw new Error(`Clear failed: ${clearResponse.status}`);
      }

      const clearResult = await clearResponse.json();
      if (!clearResult.success) {
        throw new Error(`Clear failed: ${clearResult.message}`);
      }

      await new Promise((resolve) => setTimeout(resolve, 2000));

      // Test document readiness
      // console.log("🔍 Testing document readiness...");
      const testResponse = await fetch(`${BACKEND_URL}/api/command`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          user_input: "refresh_geometry",
          context: {},
          branch_id: userBranchId,
        }),
        signal: AbortSignal.timeout(15000),
      });

      const testResult = await testResponse.json();
      if (!testResult.success) {
        throw new Error("Document not ready after clear");
      }

      // console.log("✅ Backend setup complete");

      // Update branch
      if (onBranchChange) {
        onBranchChange(userBranchId);
      }

      // Store project info (CRITICAL - same as ProjectDashboard)
      sessionStorage.setItem(`project_${docRef.id}_name`, projectName);
      sessionStorage.setItem(`project_${docRef.id}_branch`, userBranchId);

      // Store pending command (CRITICAL - same as ProjectDashboard)
      const pendingCommand = {
        userInput: userInput,
        originalInput: userInput,
        selectionContext: [],
        browserSelectionData: { edges: [], faces: [] },
        timestamp: Date.now(),
        projectId: docRef.id,
        branchId: userBranchId,
      };
      sessionStorage.setItem("pendingCommand", JSON.stringify(pendingCommand));
      sessionStorage.setItem("stripe_return_project", docRef.id);

      // Set color based on theme
      const htmlElement = document.querySelector("html");
      const bodyElement = document.body;
      const isDarkMode =
        htmlElement?.classList.contains("dark-theme") ||
        bodyElement?.classList.contains("dark-theme");
      const defaultColor = isDarkMode ? "6f6f6f" : "8d8d8d";
      sessionStorage.setItem(`project_${docRef.id}_color`, defaultColor);

      // console.log(`🎨 Set default color: ${defaultColor}`);

      // Notify parent component
      // Notify parent component AND refresh toolbar after it completes
      if (onProjectCreated) {
        onProjectCreated(docRef.id);

        // Wait for next tick to ensure parent state has updated
        requestAnimationFrame(() => {
          requestAnimationFrame(async () => {
            if ((window as any).__refreshTopToolbarProjects) {
              await (window as any).__refreshTopToolbarProjects();
            }
          });
        });
      }

      // Update URL
      window.history.replaceState({}, "", `/models/${docRef.id}`);

      // console.log(`✅ Project creation complete: ${docRef.id}`);

      return docRef.id;
    };

    const isExecutingRef = useRef(false);
    const lockedBranchRef = useRef<string | null>(null);

    const lastUserCommandTime = useRef<number>(Date.now());

    const executeCommand = async (userInput: string): Promise<any> => {
      thinkingStartTimeRef.current = Date.now();

      const currentPath = window.location.pathname;
      const isOnShareUrl = currentPath.startsWith("/share/");
      const isThisTabShared = isActiveTabShared === true;

      if (isOnShareUrl && !isThisTabShared) {
        // console.log(
        //   "📌 Executing on non-shared tab while on share URL - bypassing shared view loading"
        // );
        sessionStorage.removeItem("isSharedView");
        sessionStorage.removeItem("shareToken");

        // ✅ ADD THIS: Set a global flag that App.tsx can check
        (window as any).__suppressSharedViewLoading = true;
      }

      // Dispatch event
      window.dispatchEvent(new CustomEvent("commandExecuting"));
      // NEW: Check if we need to create a project first
      if (!projectId) {
        // console.log("📦 No project yet - creating one...");

        try {
          const newProjectId = await createProjectAndExecute(userInput);
          // console.log(`✅ Project created: ${newProjectId}`);
          // console.log(
          //   `📌 Command stored, will auto-execute when project loads`
          // );

          // ← REMOVED: Don't turn off loading - keep "Thinking..." active
          // The pending command will execute and turn off loading when complete

          // ✅ ADD THIS: Refresh TopToolbar after project creation completes
          setTimeout(async () => {
            if ((window as any).__refreshTopToolbarProjects) {
              await (window as any).__refreshTopToolbarProjects();
            }
          }, 500);

          return true;
          // Note: projectId is still null in this execution context,
          // but the NEXT command will have it set
        } catch (error) {
          // console.error("Failed to create project:", error);

          // Remove the user message that was just added
          setChatMessages((prev) => prev.slice(0, -1));

          setErrorMessage({
            message: "Failed to create project. Please try again.",
            type: "general",
          });

          // Restore input
          setInputValue(userInput.replace(/^GENERATE with .*?: /, ""));
          setIsLoading(false);
          onLoadingChange?.(false);

          // 👇👇👇 ADD THIS BLOCK 👇👇👇
          // If this is a fresh project with no geometry, kill it
          if (
            projectId &&
            onInitialCreationError &&
            (!noahGeometry || noahGeometry.length === 0) &&
            chatMessages.length <= 1
          ) {
            onInitialCreationError(projectId);
          }
          // 👆👆👆 END ADDITION 👆👆👆

          return false;
        }
      }

      const executionBranchId = currentBranch;
      setCurrentUserInput(userInput);

      lockedBranchRef.current = executionBranchId;
      // console.log(
      //   `🔒 LOCKED BRANCH: ${executionBranchId} for command: ${userInput}`
      // );

      // Guard against duplicate calls
      if (isExecutingRef.current) {
        // console.log("Command already executing, skipping duplicate");
        return false;
      }
      isExecutingRef.current = true;

      // Set global operation lock
      (window as any).__operationInProgress = true;

      // 🔒 CRITICAL: Store locked branch globally for save to access
      (window as any).__currentExecutionBranch = executionBranchId;

      let commandEndCalled = false;
      let backendTimedOut = false;

      lastUserCommandTime.current = Date.now();
      (window as any).__lastCommandTime = Date.now();

      if (onCommandStart) {
        onCommandStart();
      }

      // console.log(`Executing command with LOCKED branch: ${executionBranchId}`);

      // Apply reverse mapping to convert display names (Extrude, Cut, Shell) to technical names (Pad, Pocket, Thickness)
      const reverseMapping: { [key: string]: string } = {
        Extrude: "Pad",
        Cut: "Pocket",
        Shell: "Thickness",
      };

      let preprocessedInput = userInput;
      for (const [displayTerm, techTerm] of Object.entries(reverseMapping)) {
        const regex = new RegExp(`\\b${displayTerm}(\\d{3})\\b`, "gi");
        preprocessedInput = preprocessedInput.replace(regex, `${techTerm}$1`);
      }

      const processedInput = onProcessUserInput
        ? onProcessUserInput(preprocessedInput)
        : preprocessedInput;

      try {
        const selectionContext = await buildSelectionContext();

        const browserSelectionData: {
          edges?: Array<{
            index: number;
            coordinates: number[];
            length: number;
            object: string;
          }>;
          faces?: Array<{
            index: number;
            center: number[];
            normal: number[];
            area: number;
            object: string;
          }>;
        } = {
          edges: parsedSelection
            .filter((s) => s.type === "edge")
            .map((s) => ({
              index: s.index,
              coordinates: Array.isArray(s.browserCoordinates)
                ? s.browserCoordinates.flat()
                : s.browserCoordinates || [],
              length: s.length || 0,
              object: s.object || "Body",
            })),
          faces: parsedSelection
            .filter((s) => s.type === "face")
            .map((s) => ({
              index: s.index,
              center: s.browserFaceData?.center || [],
              normal: s.browserFaceData?.normal || [],
              area: s.browserFaceData?.area || 0,
              object: s.object || "Body",
            })),
        };

        // 🔍 PREFLIGHT DIAGNOSTICS
        // console.log(`🔍 DEBUG: About to send command "${processedInput}"`);
        // console.log(`🔍 DEBUG: Selection context:`, selectionContext);
        // console.log(`🔍 DEBUG: Branch ID:`, executionBranchId);

        try {
          const preflightResponse = await fetch(`${BACKEND_URL}/api/command`, {
            method: "POST",
            credentials: "include",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              user_input: "DEBUG_DOCUMENT_STATE",
              context: {},
              branch_id: executionBranchId,
            }),
            signal: AbortSignal.timeout(30000),
          });

          if (preflightResponse.ok) {
            const preflightResult = await preflightResponse.json();
            // console.log(`🔍 PREFLIGHT CHECK:`, {
            //   bodies: preflightResult.debug_data?.bodies,
            //   totalObjects: preflightResult.debug_data?.total_objects,
            //   hasActiveBody: preflightResult.debug_data?.active_body
            //     ? true
            //     : false,
            //   activeBodyName: preflightResult.debug_data?.active_body,
            // });
          }
        } catch (preflightError) {
          // console.warn(`⚠️ PREFLIGHT: Could not check state:`, preflightError);
        }

        const commandPromise = noahClientRef.current.executeCommand(
          processedInput,
          selectionContext,
          executionBranchId,
        );

        const timeoutPromise = new Promise((_, reject) => {
          setTimeout(() => {
            reject(new Error("Operation timed out after 30 seconds"));
          }, 300000);
        });

        const noahResponse = (await Promise.race([
          commandPromise,
          timeoutPromise,
        ])) as any;

        // ADD THIS - Log the full response
        // console.log("🔥 RAW BACKEND RESPONSE:", noahResponse);
        // console.log("🔥 RESPONSE SUCCESS:", noahResponse?.success);
        // console.log("🔥 RESPONSE MESSAGE:", noahResponse?.message);
        // console.log("🔥 RESPONSE ERROR:", noahResponse?.error);

        if (!noahResponse) {
          throw new Error("No response received from Noah backend");
        }

        if (noahResponse.success) {
          // 1. Rename project immediately if backend suggests a name
          if (noahResponse.suggested_name && onTabRename) {
            const targetId = activeModelId || projectId;
            if (targetId) {
              onTabRename(targetId, noahResponse.suggested_name);
            }
          }

          // 2. Ensure user exists
          if (!user) {
            setErrorMessage({
              message: "User not authenticated",
              type: "general",
            });
            setIsLoading(false);
            onLoadingChange?.(false);
            return false;
          }

          // 3. CREDIT CHECK: Only run for non-Pro users
          const tier = userProfile?.subscriptionTier || "free";

          if (tier !== "pro" && tier !== "enterprise") {
            const userRef = doc(db, "users", user.uid);
            const creditCheck = await checkAndConsumeCredits(
              userRef,
              userProfile,
              user.uid,
            );

            if (!creditCheck.allowed) {
              // Store pending command for retry after purchase
              const pendingCommand = {
                userInput: processedInput,
                originalInput: userInput,
                selectionContext: selectionContext,
                browserSelectionData: browserSelectionData,
                timestamp: Date.now(),
                projectId: projectId,
                branchId: executionBranchId,
              };

              sessionStorage.setItem(
                "pendingCommand",
                JSON.stringify(pendingCommand),
              );

              // UI Cleanup: Stop loading and show modal
              setChatMessages((prev) => prev.slice(0, -1));
              setInputValue(userInput.replace(/^GENERATE with .*?: /, ""));
              setIsLoading(false);
              onLoadingChange?.(false);
              onShowCreditsModal?.();

              setErrorMessage({
                message: "Uh-oh, you're out of credits.",
                type: "credits",
              });

              // Clean up new project if it failed on first prompt
              if (
                projectId &&
                onInitialCreationError &&
                (!noahGeometry || noahGeometry.length === 0) &&
                chatMessages.length <= 1
              ) {
                onInitialCreationError(projectId);
              }
              return false;
            }
          }

          // 4. BEYOND THIS POINT: User is either Pro OR has remaining credits
          // We proceed to verify and render the geometry.
          let fcstdBase64: string | undefined;
          let fileSize = 0;
          let exportObjectCount = 0;

          try {
            // Step 1: Check if backend returned geometry in the response
            const responseHasGeometry =
              noahResponse.geometry && noahResponse.geometry.length > 0;

            if (!responseHasGeometry) {
              // console.error(
              //   "❌ Backend response contains NO geometry - command failed silently"
              // );
              throw new Error(
                "Backend failed to create geometry - please try creating a new project",
              );
            }

            // console.log(
            //   `✅ Command response contains ${noahResponse.geometry.length} geometry items`
            // );

            // Step 2: IMMEDIATE verification with retry on broken session
            // console.log("🔍 Verifying document state on same session...");

            let immediateBodyCount = 0;
            let sessionVerified = false;
            const maxVerifyAttempts = 3;

            for (
              let verifyAttempt = 1;
              verifyAttempt <= maxVerifyAttempts;
              verifyAttempt++
            ) {
              const immediateVerifyResponse = await fetch(
                `${BACKEND_URL}/api/command`,
                {
                  method: "POST",
                  credentials: "include",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify({
                    user_input: "DEBUG_DOCUMENT_STATE",
                    context: {},
                    branch_id: executionBranchId,
                  }),
                  signal: AbortSignal.timeout(30000),
                },
              );

              if (!immediateVerifyResponse.ok) {
                // console.error(
                //   `❌ Verification attempt ${verifyAttempt}/${maxVerifyAttempts} failed - HTTP ${immediateVerifyResponse.status}`
                // );
                if (verifyAttempt < maxVerifyAttempts) {
                  // console.log("⏳ Waiting 1s before retry...");
                  await new Promise((resolve) => setTimeout(resolve, 1000));
                  continue;
                }
                throw new Error(
                  "Lost connection to backend - please try again",
                );
              }

              const immediateVerifyResult =
                await immediateVerifyResponse.json();
              immediateBodyCount =
                immediateVerifyResult.debug_data?.bodies?.length || 0;

              if (immediateBodyCount === 0) {
                // console.error(
                //   `❌ Verification attempt ${verifyAttempt}/${maxVerifyAttempts}: Document is EMPTY - sticky session broken`
                // );

                if (verifyAttempt < maxVerifyAttempts) {
                  // console.log(
                  //   "🔄 Retrying verification to re-establish session..."
                  // );
                  await new Promise((resolve) => setTimeout(resolve, 1000));
                  continue;
                }

                // Final attempt failed
                // console.error(
                //   "❌ CRITICAL: All verification attempts failed - sticky session is BROKEN"
                // );
                // console.error(
                //   "This means command and verification consistently hit different pods"
                // );
                throw new Error(
                  "Backend session lost after multiple attempts - please try creating a new project",
                );
              }

              // Success!
              sessionVerified = true;
              // console.log(
              //   `✅ Verification attempt ${verifyAttempt}/${maxVerifyAttempts}: ${immediateBodyCount} bodies in document`
              // );
              break;
            }

            if (!sessionVerified) {
              throw new Error("Failed to verify backend session");
            }
            // Step 3: Wait for backend to finish writing to disk (recompute, etc.)
            // console.log("⏳ Waiting for backend to stabilize (3 seconds)...");
            await new Promise((resolve) => setTimeout(resolve, 3000));

            // Step 4: Final verification before export
            // console.log("🔍 Final verification before export...");
            const finalVerifyResponse = await fetch(
              `${BACKEND_URL}/api/command`,
              {
                method: "POST",
                credentials: "include",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                  user_input: "DEBUG_DOCUMENT_STATE",
                  context: {},
                  branch_id: executionBranchId,
                }),
                signal: AbortSignal.timeout(30000),
              },
            );

            if (finalVerifyResponse.ok) {
              const finalVerifyResult = await finalVerifyResponse.json();
              const finalBodyCount =
                finalVerifyResult.debug_data?.bodies?.length || 0;
              const isRecomputing =
                finalVerifyResult.debug_data?.is_recomputing || false;

              // console.log(
              //   `🔍 Final check: ${finalBodyCount} bodies, recomputing: ${isRecomputing}`
              // );

              if (finalBodyCount === 0) {
                // console.error(
                //   "❌ Geometry disappeared after stabilization - pod crashed or switched"
                // );
                throw new Error("Backend lost geometry - please try again");
              }

              if (isRecomputing) {
                // console.log(
                //   "⏳ Backend still recomputing, waiting additional 2 seconds..."
                // );
                await new Promise((resolve) => setTimeout(resolve, 2000));
              }
            }

            // Step 3: Now export (geometry is guaranteed to exist)
            // console.log("💾 Exporting project state...");
            const exportResponse = await fetch(`${BACKEND_URL}/api/command`, {
              method: "POST",
              credentials: "include",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                user_input: "EXPORT_NOAH_FILE",
                context: {},
                branch_id: executionBranchId,
              }),
              signal: AbortSignal.timeout(300000),
            });

            if (!exportResponse.ok) {
              throw new Error(`Export failed: HTTP ${exportResponse.status}`);
            }

            const exportResult = await exportResponse.json();

            if (!exportResult.success || !exportResult.fcstd_data) {
              throw new Error("Export returned no data");
            }

            fcstdBase64 = exportResult.fcstd_data;
            fileSize = exportResult.file_size || 0;
            exportObjectCount = exportResult.objects?.length || 0;

            // CRITICAL: Validate export has actual content
            if (exportObjectCount === 0 || fileSize < 2000) {
              // console.error(
              //   `⚠️ Export suspicious: ${fileSize} bytes, ${exportObjectCount} objects - retrying...`
              // );

              // Wait longer and retry ONCE
              await new Promise((resolve) => setTimeout(resolve, 3000));

              const retryExportResponse = await fetch(
                `${BACKEND_URL}/api/command`,
                {
                  method: "POST",
                  credentials: "include",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify({
                    user_input: "EXPORT_NOAH_FILE",
                    context: {},
                    branch_id: executionBranchId,
                  }),
                  signal: AbortSignal.timeout(300000),
                },
              );

              if (retryExportResponse.ok) {
                const retryResult = await retryExportResponse.json();
                if (retryResult.success && retryResult.fcstd_data) {
                  fcstdBase64 = retryResult.fcstd_data;
                  fileSize = retryResult.file_size || 0;
                  exportObjectCount = retryResult.objects?.length || 0;

                  // If STILL empty after retry, abort
                  if (exportObjectCount === 0 || fileSize < 2000) {
                    throw new Error("Export failed: File is empty after retry");
                  }

                  // console.log(
                  //   `✅ Retry export succeeded: ${fileSize} bytes with ${exportObjectCount} objects`
                  // );
                }
              } else {
                throw new Error("Retry export failed");
              }
            } else {
              // console.log(
              //   `✅ Exported ${fileSize} bytes with ${exportObjectCount} objects`
              // );
            }
          } catch (exportErr) {
            // console.error("❌ Export process failed:", exportErr);

            // Remove the user message that was just added
            setChatMessages((prev) => prev.slice(0, -1));

            // Set general error
            setErrorMessage({
              message:
                exportErr instanceof Error
                  ? exportErr.message
                  : String(exportErr),
              type: "general",
            });

            // Restore the user's input so they can retry immediately
            setInputValue(userInput.replace(/^GENERATE with .*?: /, ""));

            setIsLoading(false);
            onLoadingChange?.(false);
            if (
              projectId &&
              onInitialCreationError &&
              (!noahGeometry || noahGeometry.length === 0) &&
              chatMessages.length <= 1
            ) {
              onInitialCreationError(projectId);
            }
            // 👆👆👆 END ADDITION 👆👆👆

            return false;
          }

          // 🔧 CRITICAL: Store export data for save to pick up (using the variables from the try block)
          (window as any).__lastExportData = {
            fcstdBase64: fcstdBase64,
            fileSize: fileSize,
            objectCount: exportObjectCount,
            timestamp: Date.now(),
            branchId: executionBranchId,
          };

          // console.log(
          //   `✅ SAVE: Stored export data for save function to use (${fileSize} bytes, ${exportObjectCount} objects)`
          // );

          // In RightSidebar.tsx, REPLACE the section around line 1460-1560 with this:

          // Inside executeCommand function, after parseResponse:

          // Parse the backend response
          let { type, featureName } = parseResponse(noahResponse);

          // CRITICAL FIX: If this is a modify operation, check if the user mentioned an existing feature
          // If so, use that feature's display name instead of the backend's technical name
          if (type === "modify") {
            const userInputLower = userInput.toLowerCase();

            // Get the feature tree
            const currentFeatureTree =
              (window as any).__currentFeatureTree || [];

            // Function to find mentioned feature in user input
            const findMentionedFeature = (tree: any[]): string | null => {
              for (const item of tree) {
                const displayName = item.displayName || item.name;
                // Check if user mentioned this feature (case insensitive)
                if (userInputLower.includes(displayName.toLowerCase())) {
                  return displayName;
                }
                // Check children
                if (item.children) {
                  for (const child of item.children) {
                    const childDisplayName = child.displayName || child.name;
                    if (
                      userInputLower.includes(childDisplayName.toLowerCase())
                    ) {
                      return childDisplayName;
                    }
                  }
                }
              }
              return null;
            };

            const mentionedFeature = findMentionedFeature(currentFeatureTree);
            if (mentionedFeature) {
              // User mentioned an existing feature - use that name instead of backend's response
              featureName = mentionedFeature;
            }
          }

          // Calculate thinking duration
          const thinkingDurationMs = thinkingStartTimeRef.current
            ? Date.now() - thinkingStartTimeRef.current
            : 0;
          const thinkingDurationStr =
            formatThinkingDuration(thinkingDurationMs);

          // 🔧 CRITICAL FIX: Fetch AI response ONCE with longer timeout and retry logic
          let aiResponseText = "Done! Let me know what's next.";
          // console.log(`🤖 Fetching AI response for: ${type} - ${featureName}`);

          try {
            const aiStartTime = Date.now();

            // Increase timeout to 45 seconds to match backend processing time
            const aiResponse = await fetch(
              `${BACKEND_URL}/api/generate-response`,
              {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                  operation_type: type,
                  feature_name: featureName,
                  user_input: userInput,
                }),
                signal: AbortSignal.timeout(45000), // Increased from 30s to 45s
              },
            );

            const aiElapsed = Date.now() - aiStartTime;
            // console.log(`🤖 AI response received in ${aiElapsed}ms`);

            if (!aiResponse.ok) {
              throw new Error(`AI response failed: HTTP ${aiResponse.status}`);
            }

            const aiData = await aiResponse.json();
            // console.log(`🤖 FULL AI response:`, aiData);

            if (aiData.response && aiData.response.trim()) {
              aiResponseText = aiData.response;
              // console.log(`✅ Got AI response: ${aiResponseText}`);
            } else {
              // console.warn(`⚠️ Empty AI response, using fallback`);
            }
          } catch (aiError) {
            const aiElapsed = Date.now() - (Date.now() - thinkingDurationMs);
            // console.error(
            //   `❌ AI response fetch failed after ${aiElapsed}ms:`,
            //   aiError
            // );

            // Use fallback based on operation type
            const fallbacks = {
              create: "Done! Let me know what's next.",
              modify: "Changes applied. Anything else?",
              delete: "Removed. Need anything else?",
            };
            aiResponseText =
              fallbacks[type as keyof typeof fallbacks] || fallbacks.create;
            // console.log(`🔧 Using fallback text: ${aiResponseText}`);
          }

          // NOW create assistantMessage with the AI text we just fetched
          const assistantMessage: ChatMessage = {
            id: Date.now() + 1,
            type: "assistant",
            content: "",
            originalContent: "",
            responseType: type,
            featureName: "",
            backendMessageId: noahResponse.message_id,
            thinkingDuration: thinkingDurationStr,
            aiResponseText: aiResponseText, // ← Use the text we just fetched
            selectionContext: {
              edges: parsedSelection.filter((s) => s.type === "edge").length,
              faces: parsedSelection.filter((s) => s.type === "face").length,
            },
          };

          // Step 4: Rest of your code (onFeatureCreated, etc.)
          const cleanSelectionContext = {
            ...selectionContext,
            selection: selectionContext.selection.map((sel: any) => ({
              ...sel,
              browser_coordinates: sel.browser_coordinates
                ? sel.browser_coordinates.map((coords: any) =>
                    Array.isArray(coords) ? coords.flat() : coords,
                  )
                : undefined,
            })),
          };

          const commandEntry: CommandHistoryEntry = {
            userInput: userInput,
            originalUserInput: inputValue.trim(),
            selectionContext: cleanSelectionContext.selection || [],
            messageId: assistantMessage.id,
            timestamp: Date.now(),
            browserSelectionData: browserSelectionData,
            fullSelectionContext: cleanSelectionContext,
          };

          if (noahResponse.geometry !== undefined) {
            if (noahResponse.geometry && noahResponse.geometry.length > 0) {
              // console.log(
              //   `✅ STABILIZE: Backend returned ${noahResponse.geometry.length} geometry items - trusting response`
              // );

              await new Promise((resolve) => setTimeout(resolve, 500));

              // console.log("✅ STABILIZE: Complete - geometry is ready");

              // 🔒 CRITICAL: Don't show ANYTHING until save completes
              if (onShapeCreated) {
                // 🔧 NEW: Fetch FRESH geometry to avoid cached data after errors
                // console.log("🔄 Fetching fresh geometry to avoid cache...");
                let geometryToUse = noahResponse.geometry;

                try {
                  const freshGeometryResponse = await fetch(
                    `${BACKEND_URL}/api/command`,
                    {
                      method: "POST",
                      credentials: "include",
                      headers: { "Content-Type": "application/json" },
                      body: JSON.stringify({
                        user_input: "refresh_geometry",
                        context: {},
                        branch_id: executionBranchId,
                      }),
                      signal: AbortSignal.timeout(30000),
                    },
                  );

                  if (freshGeometryResponse.ok) {
                    const freshResult = await freshGeometryResponse.json();
                    if (
                      freshResult.success &&
                      freshResult.geometry?.length > 0
                    ) {
                      // console.log(
                      //   `✅ Got FRESH geometry: ${freshResult.geometry.length} items`
                      // );
                      // console.log("🔍 FRESH GEOMETRY FROM BACKEND:", {
                      //   geometryCount: freshResult.geometry?.length,
                      //   firstGeomPreview:
                      //     freshResult.geometry?.[0]?.stl_data?.substring(
                      //       0,
                      //       100
                      //     ),
                      //   geometryObjects: freshResult.geometry?.map(
                      //     (g: any) => ({
                      //       name: g.name,
                      //       type: g.type,
                      //       hasSTL: !!g.stl_data,
                      //       stlLength: g.stl_data?.length,
                      //     })
                      //   ),
                      // });
                      geometryToUse = freshResult.geometry; // Use fresh geometry instead
                    } else {
                      // console.warn(
                      //   "⚠️ Fresh geometry fetch failed, using response geometry"
                      // );
                    }
                  }
                } catch (fetchError) {
                  // console.warn(
                  //   "⚠️ Could not fetch fresh geometry:",
                  //   fetchError
                  // );
                  // Fall back to response geometry
                }

                // 🔧 CRITICAL: Call onFeatureCreated FIRST to update tree BEFORE save
                let finalDisplayName = featureName;
                if (onFeatureCreated) {
                  const actualName = onFeatureCreated(
                    featureName,
                    type as "create" | "modify" | "delete",
                    assistantMessage.id,
                    commandEntry,
                  );
                  if (actualName) {
                    finalDisplayName = actualName;
                  }
                }

                // Process AI response
                if (onProcessAIResponse) {
                  finalDisplayName = onProcessAIResponse(finalDisplayName);
                }

                // Update assistant message - 🔧 CRITICAL: SET aiResponseText HERE
                assistantMessage.content = finalDisplayName; // ← This is the feature name
                assistantMessage.originalContent = finalDisplayName;
                assistantMessage.featureName = finalDisplayName;
                assistantMessage.aiResponseText = aiResponseText; // ← ADD THIS LINE (it was already there but verify)

                // 🔧 CRITICAL: Add chat message BEFORE save (so it gets included)
                setChatMessages((prev) => {
                  const newMessages = [...prev, assistantMessage];
                  // console.log(
                  //   `✅ Added assistant message to chat: ${finalDisplayName}`
                  // );
                  // console.log(`✅ AI response text: ${aiResponseText}`);
                  // console.log(`✅ Total messages now: ${newMessages.length}`);
                  return newMessages;
                });

                // 🔧 CRITICAL: Use FRESH geometry (not cached response geometry)
                const newGeometry = geometryToUse.map((g: any, idx: number) => {
                  return JSON.parse(
                    JSON.stringify({
                      ...g,
                      _forceUpdate: `${Date.now()}_${Math.random()}_${idx}_${Math.random()}`,
                      _operationId: assistantMessage.id,
                      _timestamp: Date.now(),
                      _recoveryFlag: Math.random(),
                    }),
                  );
                });

                // console.log(
                //   `📦 NEW GEOMETRY CREATED - COUNT: ${newGeometry.length}`
                // );
                // console.log(
                //   `📦 NEW GEOMETRY MARKERS:`,
                //   newGeometry.map((g: any) => g._forceUpdate)
                // );
                // console.log(`📦 ABOUT TO CALL onShapeCreated with geometry`);

                // 👇👇👇 INJECT YOUR CODE HERE 👇👇👇

                // 🔧 CRITICAL: Refresh export timestamp before saving to prevent expiry
                if ((window as any).__lastExportData) {
                  console.log(
                    "🔄 DEBUG: Refreshing export timestamp before save (was " +
                      (Date.now() -
                        (window as any).__lastExportData.timestamp) +
                      "ms old)",
                  );
                  (window as any).__lastExportData.timestamp = Date.now();
                } else {
                  console.warn(
                    "⚠️ DEBUG: No export data found to refresh! Save may store metadata only.",
                  );
                }

                // 👆👆👆 END INJECTION 👆👆👆

                // NOW save (tree AND chat are both updated)
                onShapeCreated(newGeometry, () => {
                  setCurrentTypingMessageId(assistantMessage.id);
                  setTypingText(finalDisplayName);
                  setIsLoading(false);
                  onLoadingChange?.(false);

                  // FORCE SCROLL TO BOTTOM after message is displayed
                  setTimeout(() => {
                    if (chatMessagesRef.current) {
                      chatMessagesRef.current.scrollTop =
                        chatMessagesRef.current.scrollHeight;
                    }
                  }, 150);
                });

                // console.log(`📦 onShapeCreated CALLED - waiting for callback`);
              } else {
                // Fallback if no save handler
                let fallbackDisplayName = featureName;

                if (onFeatureCreated) {
                  const actualName = onFeatureCreated(
                    featureName,
                    type as "create" | "modify" | "delete",
                    assistantMessage.id,
                    commandEntry,
                  );
                  if (actualName) {
                    fallbackDisplayName = actualName;
                  }
                }

                if (onProcessAIResponse) {
                  fallbackDisplayName =
                    onProcessAIResponse(fallbackDisplayName);
                }

                assistantMessage.content = fallbackDisplayName;
                assistantMessage.originalContent = fallbackDisplayName;
                assistantMessage.featureName = fallbackDisplayName;

                setChatMessages((prev) => [...prev, assistantMessage]);
                setCurrentTypingMessageId(assistantMessage.id);
                setTypingText(fallbackDisplayName);
                setIsLoading(false);
                onLoadingChange?.(false);

                // FORCE SCROLL TO BOTTOM
                setTimeout(() => {
                  if (chatMessagesRef.current) {
                    chatMessagesRef.current.scrollTop =
                      chatMessagesRef.current.scrollHeight;
                  }
                }, 150);
              }
            } else {
              // 🔧 FIX: If geometry is empty, we still need to call onShapeCreated to clear the view
              // console.log("⚠️ No geometry in response, clearing view");
              if (onShapeCreated) {
                onShapeCreated([], undefined, true);
              }
              setIsLoading(false);
              onLoadingChange?.(false);
            }
          } else {
            // 🔧 FIX: If geometry field is missing entirely, try to fetch it
            // console.log(
            //   "⚠️ No geometry field in response, fetching current state..."
            // );

            try {
              const refreshResponse = await fetch(
                `${BACKEND_URL}/api/command`,
                {
                  method: "POST",
                  credentials: "include",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify({
                    user_input: "refresh_geometry",
                    context: {},
                    branch_id: executionBranchId,
                  }),
                  signal: AbortSignal.timeout(30000),
                },
              );

              if (refreshResponse.ok) {
                const refreshResult = await refreshResponse.json();
                if (
                  refreshResult.success &&
                  refreshResult.geometry?.length > 0
                ) {
                  // console.log(
                  //   `✅ Fetched ${refreshResult.geometry.length} geometry items after missing geometry field`
                  // );

                  // Process the fetched geometry the same way as normal geometry
                  let finalDisplayName = featureName;
                  if (onFeatureCreated) {
                    const actualName = onFeatureCreated(
                      featureName,
                      type as "create" | "modify" | "delete",
                      assistantMessage.id,
                      commandEntry,
                    );
                    if (actualName) {
                      finalDisplayName = actualName;
                    }
                  }

                  if (onProcessAIResponse) {
                    finalDisplayName = onProcessAIResponse(finalDisplayName);
                  }

                  assistantMessage.content = finalDisplayName;
                  assistantMessage.originalContent = finalDisplayName;
                  assistantMessage.featureName = finalDisplayName;

                  setChatMessages((prev) => {
                    const newMessages = [...prev, assistantMessage];
                    // console.log(
                    //   `✅ Added assistant message to chat: ${finalDisplayName}`
                    // );
                    return newMessages;
                  });

                  if (onShapeCreated) {
                    onShapeCreated(refreshResult.geometry, () => {
                      setCurrentTypingMessageId(assistantMessage.id);
                      setTypingText(finalDisplayName);
                      setIsLoading(false);
                      onLoadingChange?.(false);
                    });
                  }
                } else {
                  // console.log("⚠️ Refresh returned no geometry");
                  setIsLoading(false);
                }
              } else {
                // console.error(
                //   "❌ Failed to fetch geometry:",
                //   refreshResponse.status
                // );
                setIsLoading(false);
              }
            } catch (error) {
              // console.error("❌ Failed to fetch geometry:", error);
              setIsLoading(false);
              onLoadingChange?.(false);
            }
          }

          if (noahResponse.branch_info) {
            const branchInfo = noahResponse.branch_info;
            if (branchInfo.active_branch && onBranchChange) {
              onBranchChange(branchInfo.active_branch);
            }
          }

          return noahResponse;
        } else {
          // Show the FULL error details
          const errorMsg =
            noahResponse.message || noahResponse.error || "Unknown error";

          // Remove the user message that was just added
          setChatMessages((prev) => prev.slice(0, -1));

          // Set error state instead of adding to chat
          setErrorMessage({
            message: "Uh-oh, something broke.",
            type: "general",
          });

          // Restore the user's input
          setInputValue(userInput.replace(/^GENERATE with .*?: /, ""));
          setIsLoading(false);
          onLoadingChange?.(false);

          // 👇👇👇 ADD THIS BLOCK 👇👇👇
          // If this is a fresh project with no geometry, kill it
          if (
            projectId &&
            onInitialCreationError &&
            (!noahGeometry || noahGeometry.length === 0) &&
            chatMessages.length <= 1
          ) {
            onInitialCreationError(projectId);
          }
          // 👆👆👆 END ADDITION 👆👆👆

          return false;
        }
      } catch (error) {
        // console.error("🔥 CAUGHT ERROR:", error);

        const errorMessage =
          error instanceof Error ? error.message : String(error);

        if (errorMessage.includes("cancelled")) {
          setIsLoading(false);
          return false;
        }

        // NEW: Mark error time and force next geometry to bypass defer
        (window as any).__lastErrorTime = Date.now();
        (window as any).__forceNextGeometryUpdate = true;

        // ✅ EXISTING ERROR RECOVERY CODE - Make sure it's here!
        try {
          // console.log("🔄 Forcing geometry refresh after error...");
          const refreshResponse = await fetch(`${BACKEND_URL}/api/command`, {
            method: "POST",
            credentials: "include",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              user_input: "refresh_geometry",
              context: {},
              branch_id: executionBranchId,
            }),
            signal: AbortSignal.timeout(30000),
          });

          if (refreshResponse.ok) {
            const refreshResult = await refreshResponse.json();
            if (refreshResult.success && refreshResult.geometry?.length > 0) {
              // console.log(
              //   `✅ Post-error refresh: ${refreshResult.geometry.length} items`
              // );

              const errorRecoveryGeometry = refreshResult.geometry.map(
                (g: any) => ({
                  ...g,
                  _forceUpdate: `error_recovery_${Date.now()}_${Math.random()}`,
                  _errorRecovery: true, // ← CRITICAL: This flag triggers camera auto-fit
                }),
              );

              if (onShapeCreated) {
                onShapeCreated(
                  errorRecoveryGeometry,
                  () => {
                    // console.log("✅ Geometry synchronized after error");
                  },
                  true, // bypassDefer flag
                );
              }
            }
          }
        } catch (refreshError) {
          // console.warn(
          //   "⚠️ Could not refresh geometry after error:",
          //   refreshError
          // );
        }

        // Remove the user message that was just added
        setChatMessages((prev) => prev.slice(0, -1));

        // Set general error (not credits-specific)
        setErrorMessage({
          message: "Uh-oh, something broke.",
          type: "general",
        });

        // Restore the user's input so they can retry immediately
        setInputValue(userInput.replace(/^GENERATE with .*?: /, ""));
        setIsLoading(false);
        onLoadingChange?.(false);
        if (
          projectId &&
          onInitialCreationError &&
          (!noahGeometry || noahGeometry.length === 0) &&
          chatMessages.length <= 1
        ) {
          onInitialCreationError(projectId);
        }
        // 👆👆👆 END ADDITION 👆👆👆

        return false;
      } finally {
        if (onCommandEnd && !commandEndCalled && !backendTimedOut) {
          onCommandEnd();
        }

        isExecutingRef.current = false;
        (window as any).__operationInProgress = false;
        lockedBranchRef.current = null;
        delete (window as any).__currentExecutionBranch;
        thinkingStartTimeRef.current = null;
        onLoadingChange?.(false);

        // ✅ ADD THIS: Clear the suppression flag
        delete (window as any).__suppressSharedViewLoading;
      }
    };

    // Inside RightSidebar component, add this after other state declarations:
    const typingPhrases = useMemo(
      () => [
        "Create an electronics enclosure",
        "Create a 2x2 LEGO brick",
        "Create a simple stool",
        "Create a cable organizer",
        "Create a toothbrush holder",
        "Create a door handle",
        "Create a simple joystick",
        "Create a mounting bracket",
      ],
      [],
    );

    const typingPlaceholder = useTypingPlaceholder(
      typingPhrases,
      chatMessages.length === 0,
    );

    // Get user's first name
    const userFirstName =
      userProfile?.fullName?.split(" ")[0] ||
      userProfile?.displayName?.split(" ")[0] ||
      "there";

    const handleRetry = useCallback(
      async (messageId: number) => {
        // Clear error state
        setErrorMessage(null);

        // Find the user message that caused this error
        const errorMessageIndex = chatMessages.findIndex(
          (msg) => msg.id === messageId,
        );
        if (errorMessageIndex === -1 || errorMessageIndex === 0) return;

        const userMessage = chatMessages[errorMessageIndex - 1];
        if (!userMessage || userMessage.type !== "user") return;

        let userInput = userMessage.content;

        // console.log(`Retrying command: ${userInput}`);

        // Wait for selection to be restored (if it was pending)
        const waitForSelection = () => {
          return new Promise<void>((resolve) => {
            const checkInterval = setInterval(() => {
              if (
                (window as any).__selectionRestored ||
                !(window as any).__restoreSelection
              ) {
                clearInterval(checkInterval);
                delete (window as any).__selectionRestored;
                resolve();
              }
            }, 50);

            // Timeout after 2 seconds
            setTimeout(() => {
              clearInterval(checkInterval);
              resolve();
            }, 2000);
          });
        };

        await waitForSelection();

        // Remove the error message pair (user + error)
        setChatMessages((prev) => {
          const filtered = [];
          for (let i = 0; i < prev.length; i += 2) {
            const userMsg = prev[i];
            const assistantMsg = prev[i + 1];

            if (assistantMsg && assistantMsg.id === messageId) {
              continue;
            }

            filtered.push(userMsg);
            if (assistantMsg) {
              filtered.push(assistantMsg);
            }
          }
          return filtered;
        });

        // Re-add the user message
        const newUserMessage: ChatMessage = {
          id: Date.now(),
          type: "user",
          content: userInput,
        };

        setChatMessages((prev) => [...prev, newUserMessage]);

        // Execute the command again
        setIsLoading(true);
        onLoadingChange?.(true);

        setTypingText("");
        setCurrentTypingMessageId(null);

        try {
          await executeCommand(userInput);
        } catch (error) {
          // console.error("Retry failed:", error);
          setIsLoading(false);
        }
      },
      [chatMessages, executeCommand],
    );

    // NOW declare sendInitialPrompt AFTER executeCommand
    const sendInitialPrompt = useCallback(
      async (prompt: string) => {
        if (!prompt.trim()) {
          return;
        }

        // console.log(`Auto-executing pending command: ${prompt}`);

        // ← DON'T add a user message - it's already there!
        // ← DON'T clear messages - nothing to clear!
        // ← Just execute the command!

        setIsLoading(true);
        onLoadingChange?.(true);

        try {
          await executeCommand(prompt);
        } catch (error) {
          // console.error("Failed to execute pending command:", error);
          setIsLoading(false);
          onLoadingChange?.(false);
        }
      },
      [executeCommand, onLoadingChange],
    );

    // Restore project context when returning from Stripe (manual credit purchase)
    // Restore project context when returning from Stripe (manual credit purchase)
    // Restore project context when returning from Stripe (manual credit purchase)
    useEffect(() => {
      const restoreContext = (window as any).__restoreProjectContext;

      if (restoreContext) {
        // console.log("📥 RightSidebar restoring context:", restoreContext);

        // NEW: Don't restore input immediately - wait for selection to be ready
        // This prevents the jarring effect of text appearing before selection
        if (restoreContext.selection && restoreContext.selection.length > 0) {
          // console.log(
          //   "✅ Selection context available:",
          //   restoreContext.selection.length,
          //   "items - waiting for visual restoration"
          // );

          // The View component will signal when selection is visually restored
          // via the __selectionRestored flag
          const checkSelectionRestored = () => {
            if ((window as any).__selectionRestored) {
              // NOW restore the input text
              if (restoreContext.input) {
                setInputValue(restoreContext.input);
                // console.log(
                //   "✅ Restored input after selection:",
                //   restoreContext.input
                // );
              }

              // Clean up flags
              delete (window as any).__restoreProjectContext;
              delete (window as any).__selectionRestored;
            } else {
              // Keep checking until selection is restored
              setTimeout(checkSelectionRestored, 100);
            }
          };

          checkSelectionRestored();
        } else if (restoreContext.input) {
          // No selection to restore, just restore input immediately
          setInputValue(restoreContext.input);
          // console.log(
          //   "✅ Restored input (no selection):",
          //   restoreContext.input
          // );
          delete (window as any).__restoreProjectContext;
        } else {
          // Clean up if nothing to restore
          delete (window as any).__restoreProjectContext;
        }
      }
    }, []); // Run once on mount

    // Check for pending command after successful purchase
    // Check for pending command after successful purchase
    // Restore pending command text to input (but don't auto-send)
    // Restore pending command text to input (but don't auto-send)
    // Check for pending command after successful purchase
    // Check for pending command after successful purchase
    // Check for pending command after successful purchase
    // Check for pending command after successful purchase
    // Check for pending command after successful purchase
    useEffect(() => {
      const pendingCommandStr = sessionStorage.getItem("pendingCommand");

      if (!pendingCommandStr) return;

      try {
        const pendingCommand = JSON.parse(pendingCommandStr);
        // console.log("📦 PENDING COMMAND FOUND:", pendingCommand);

        // ← CHANGED: Only verify if projectId exists AND matches
        // Don't remove if projectId is null - it might just be loading
        if (projectId && pendingCommand.projectId !== projectId) {
          // console.log(
          //   "❌ Project ID mismatch:",
          //   pendingCommand.projectId,
          //   "vs",
          //   projectId
          // );
          sessionStorage.removeItem("pendingCommand");
          return;
        }

        // ← ADDED: Wait for projectId to be set
        if (!projectId) {
          // console.log("⏳ Waiting for projectId to be set...");
          return;
        }

        // Check if we just returned from Stripe
        const searchParams = new URLSearchParams(window.location.search);
        const justReturnedFromStripe =
          searchParams.has("success") && searchParams.get("type") === "credits";

        // Only proceed if user has credits OR just returned from Stripe
        if (
          !justReturnedFromStripe &&
          (!userProfile?.credits || userProfile.credits <= 0)
        ) {
          // console.log("❌ No credits and not from Stripe");
          return;
        }

        // console.log(
        //   "✅ Pending command found, auto-executing:",
        //   pendingCommand.originalInput
        // );

        // Clear FIRST
        sessionStorage.removeItem("pendingCommand");
        sessionStorage.removeItem("stripe_return_project");

        // Auto-send the command
        setTimeout(() => {
          sendInitialPrompt(pendingCommand.originalInput);
        }, 1000);
      } catch (error) {
        // console.error("Error restoring pending command:", error);
        sessionStorage.removeItem("pendingCommand");
      }
    }, [projectId, userProfile?.credits, sendInitialPrompt]);
    // Place useImperativeHandle AFTER both functions are declared
    React.useImperativeHandle(
      ref,
      () => ({
        updateChatMessages: updateChatMessagesForRename,
        clearChat: clearChat,
        setChatMessages: setChatMessages,
        getChatMessages: () => chatMessages, // This line is critical
        sendInitialPrompt: sendInitialPrompt,
        focusInput: () => {
          if (inputTextareaRef.current) {
            inputTextareaRef.current.focus();
          }
        },
      }),
      [updateChatMessagesForRename, clearChat, chatMessages, sendInitialPrompt],
    );

    const handleSendClick = async () => {
      // Clear any previous error
      setErrorMessage(null);

      if (inputValue.trim() && !isLoading && connectionStatus === "connected") {
        const originalInput = inputValue.trim();

        // Debug command check
        if (originalInput.toLowerCase() === "debug noah") {
          debugNoahState();
          setInputValue("");
          return;
        }

        // ✅ NEW: If this is the VERY FIRST command and no project exists yet
        // Check both chatMessages length AND explicit project existence
        const isFirstCommand =
          chatMessages.length === 0 &&
          (!noahGeometry || noahGeometry.length === 0);

        let commandToSend = originalInput;

        if (isFirstCommand) {
          // Silent injection: The backend sees this, the user does not.
          commandToSend = `GENERATE with ${selectedModel}: ${originalInput}`;
        }

        // STORE CURRENT SELECTION BEFORE CLEARING (for error recovery)
        const currentSelectionBackup = JSON.parse(
          JSON.stringify(parsedSelection),
        );

        const processedInput = onProcessUserInput
          ? onProcessUserInput(originalInput)
          : originalInput;

        // Remove error message pairs
        setChatMessages((prev) => {
          const filtered = [];
          for (let i = 0; i < prev.length; i += 2) {
            const userMsg = prev[i];
            const assistantMsg = prev[i + 1];

            if (!assistantMsg || assistantMsg.responseType !== "error") {
              filtered.push(userMsg);
              if (assistantMsg) {
                filtered.push(assistantMsg);
              }
            }
          }
          return filtered;
        });

        const userMessage: ChatMessage = {
          id: Date.now(),
          type: "user",
          content: originalInput, // Display original
          selectionContext: {
            edges: parsedSelection.filter((s) => s.type === "edge").length,
            faces: parsedSelection.filter((s) => s.type === "face").length,
          },
        };

        setChatMessages((prev) => [...prev, userMessage]);

        // ✅ CLEAR INPUT IMMEDIATELY - moved here
        setInputValue("");

        setIsLoading(true);
        onLoadingChange?.(true);

        setTypingText("");
        setCurrentTypingMessageId(null);

        // CLEAR SELECTION IMMEDIATELY AFTER SENDING
        if (onSelectionClear) {
          onSelectionClear();
        }
        if ((window as any).__resetMeasureDistance) {
          (window as any).__resetMeasureDistance();
        }

        try {
          // ✅ PASS THE MODIFIED COMMAND (with GENERATE prefix if applicable)
          // executeCommand now returns the response object or boolean
          const response = await executeCommand(commandToSend);

          // Check if successful (response is object with success: true)
          if (response && (response === true || response.success)) {
            // Already cleared above
            setConnectionStatus("connected");

            // ✅ NEW: Auto-rename logic
            // Check if we got a suggested name back from the server
            if (
              response.suggested_name &&
              activeModelId &&
              onTabRename &&
              openModels
            ) {
              const currentModel = openModels.find(
                (m) => m.id === activeModelId,
              );

              // Only rename if it currently looks like "Untitled..."
              const isUntitled =
                currentModel &&
                (currentModel.name === "Untitled" ||
                  currentModel.name.match(/^Untitled[ _-]?\d*$/i));

              if (isUntitled) {
                // console.log(`🏷️ Auto-renaming project to: ${response.suggested_name}`);
                onTabRename(activeModelId, response.suggested_name);
              }
            }

            // ✅ NEW: For first command, force an immediate save after a short delay
            if (isFirstCommand) {
              setTimeout(async () => {
                if ((window as any).__triggerManualSave) {
                  await (window as any).__triggerManualSave();
                }
              }, 2000);
            }
          } else {
            // ✅ RESTORE INPUT ON FAILURE
            setInputValue(originalInput);
            // RESTORE SELECTION ON FAILURE
            (window as any).__restoreSelection = currentSelectionBackup;
          }
        } catch (error) {
          // ✅ RESTORE INPUT ON ERROR
          setInputValue(originalInput);
          // RESTORE SELECTION ON ERROR
          (window as any).__restoreSelection = currentSelectionBackup;
        }
      }
    };

    useEffect(() => {
      const textarea = inputTextareaRef.current;
      if (!textarea) return;

      // Reset height to auto to correctly calculate new scrollHeight
      textarea.style.height = "auto";
      const scrollHeight = textarea.scrollHeight;

      const minHeight = 24; // Single line height
      const maxHeight = 320; // Max growth

      const newHeight = Math.min(Math.max(scrollHeight, minHeight), maxHeight);

      textarea.style.height = `${newHeight}px`;

      // Set overflow if we hit max height
      if (scrollHeight > maxHeight) {
        textarea.style.overflowY = "auto";
      } else {
        textarea.style.overflowY = "hidden";
      }
    }, [inputValue]);
    // Replace the handleKeyDown function (around line 1840)
    // Replace the handleKeyDown function (around line 1900)
    const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
      // Cmd+K is handled by global listener, so skip it here
      if ((isMac ? e.metaKey : e.ctrlKey) && e.key.toLowerCase() === "k") {
        e.preventDefault();
        return;
      }

      if (showMentionMenu) {
        if (e.key === "ArrowDown") {
          e.preventDefault();
          setSelectedMentionIndex((prev) =>
            Math.min(prev + 1, filteredMentions.length - 1),
          );
          return;
        }
        if (e.key === "ArrowUp") {
          e.preventDefault();
          setSelectedMentionIndex((prev) => Math.max(prev - 1, 0));
          return;
        }
        if (e.key === "Enter" || e.key === "Tab") {
          if (filteredMentions.length > 0) {
            e.preventDefault();
            handleMentionSelect(filteredMentions[selectedMentionIndex]);
            return;
          }
        }
        if (e.key === "Escape") {
          e.preventDefault();
          setShowMentionMenu(false);
          return;
        }
      }

      if (e.key === "Enter") {
        const isMobile = window.innerWidth <= 1082;

        if (isMobile) {
          return;
        } else {
          if (e.shiftKey) {
            return;
          } else {
            e.preventDefault();
            handleSendClick();
          }
        }
      }
    };

    // Add this function after handleMentionSelect
    const renderHighlightedInput = () => {
      if (!inputValue) return null;

      const featureNames = getFlattenedFeatures.map((f) => f.displayName);
      if (featureNames.length === 0) return inputValue;

      // Sort by length descending to match longer names first
      const sortedNames = [...featureNames].sort((a, b) => b.length - a.length);

      // Create regex pattern for all feature names (case insensitive)
      const pattern = sortedNames
        .map((name) => name.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"))
        .join("|");

      if (!pattern) return inputValue;

      const regex = new RegExp(`(${pattern})`, "gi");
      const parts = inputValue.split(regex);

      return parts.map((part, index) => {
        const isFeature = featureNames.some(
          (name) => name.toLowerCase() === part.toLowerCase(),
        );

        if (isFeature) {
          return (
            <span key={index} className={styles.highlightedFeature}>
              {part}
            </span>
          );
        }
        return part;
      });
    };

    // Around line 1850, update handleClearSelection:
    const handleClearSelection = () => {
      if (onSelectionClear) {
        onSelectionClear();
      }

      // NEW: Reset measure distance in View
      if ((window as any).__resetMeasureDistance) {
        (window as any).__resetMeasureDistance();
      }
    };

    // useEffect(() => {
    //   const textarea = textareaRef.current;
    //   if (textarea) {
    //     textarea.style.height = "auto";
    //     const contentHeight = textarea.scrollHeight;
    //     const minHeight = 16;
    //     const maxHeight = 160;
    //     const newHeight = Math.max(
    //       minHeight,
    //       Math.min(contentHeight - 32, maxHeight)
    //     );
    //     textarea.style.height = `${newHeight}px`;
    //   }
    // }, [inputValue]);

    // Modified auto-scroll effect - only scroll on NEW messages, not renames
    // Modified auto-scroll effect - only scroll on NEW messages, not renames or when empty
    useEffect(() => {
      if (chatMessagesRef.current && shouldAutoScrollRef.current) {
        // Only scroll to bottom if there are messages
        if (chatMessages.length > 0) {
          chatMessagesRef.current.scrollTop =
            chatMessagesRef.current.scrollHeight;
        } else {
          // When empty, scroll to top
          chatMessagesRef.current.scrollTop = 0;
        }
      }
      // Reset to true after scroll completes
      shouldAutoScrollRef.current = true;
    }, [chatMessages]);

    // Add scroll handler to detect when content is scrolled
    // Add scroll handler to detect when content is scrolled
    // Add scroll handler to detect when content is scrolled
    useEffect(() => {
      const chatMessagesElement = chatMessagesRef.current;
      if (!chatMessagesElement) return;

      const handleScroll = () => {
        const scrollTop = chatMessagesElement.scrollTop;
        const scrollHeight = chatMessagesElement.scrollHeight;
        const clientHeight = chatMessagesElement.clientHeight;

        // Header border: show when scrolled down from top
        setIsScrolled(scrollTop > 0);

        // Content border: show when there's content that extends below the visible area
        // (regardless of current scroll position)
        const hasOverflowContent = scrollHeight > clientHeight;
        const isAtBottom = scrollTop + clientHeight >= scrollHeight - 10; // 10px threshold

        // Don't show border when chat is empty
        setIsContentScrolled(
          hasOverflowContent && !isAtBottom && chatMessages.length > 0,
        );
      };

      chatMessagesElement.addEventListener("scroll", handleScroll);

      // Check initial scroll position
      handleScroll();

      return () => {
        chatMessagesElement.removeEventListener("scroll", handleScroll);
      };
    }, [chatMessages.length]); // Add chatMessages.length as dependency

    // Ensure chat starts at top when empty
    useEffect(() => {
      if (chatMessagesRef.current && chatMessages.length === 0) {
        chatMessagesRef.current.scrollTop = 0;
      }
    }, [chatMessages.length]);

    useEffect(() => {
      if (currentMeasurement !== undefined && currentMeasurement !== null) {
        setEdgeMeasurement(currentMeasurement);
      }
    }, [currentMeasurement]);

    // Check for pending command after successful purchase
    // Check for pending command after successful purchase
    // Check for pending command after successful purchase

    const getResponseIcon = useCallback(
      (responseType: string) => {
        switch (responseType) {
          case "create":
            return createIcon;
          case "modify":
            return modifyIcon;
          case "delete":
            return deleteIcon;
          case "error":
            return errorIcon;
          default:
            return createIcon;
        }
      },
      [createIcon, modifyIcon],
    ); // Add dependencies

    const getSelectionDisplay = () => {
      const edges = parsedSelection.filter((s) => s.type === "edge").length;
      const faces = parsedSelection.filter((s) => s.type === "face").length;

      // If nothing selected
      if (edges === 0 && faces === 0) {
        return "0 Faces, 0 Edges";
      }

      // Build display parts
      const parts = [];
      if (faces === 1) parts.push("1 Face");
      else if (faces > 1) parts.push(`${faces} Faces`);

      if (edges === 1) parts.push("1 Edge");
      else if (edges > 1) parts.push(`${edges} Edges`);

      let displayText = parts.join(", ");

      // Add measurement if we have edges selected and a measurement value
      if (edges > 0 && edgeMeasurement !== null && edgeMeasurement > 0) {
        const convertedValue = convertUnit(
          edgeMeasurement,
          "mm",
          selectedUnit || "mm",
        );
        displayText += ` (${convertedValue.toFixed(2)}${selectedUnit || "mm"})`;
      }

      return displayText;
    };

    const convertUnit = (
      value: number,
      fromUnit: string,
      toUnit: string,
    ): number => {
      // Convert from source unit to mm first
      let mmValue = value;
      switch (fromUnit) {
        case "cm":
          mmValue = value * 10;
          break;
        case "m":
          mmValue = value * 1000;
          break;
        case "in":
          mmValue = value * 25.4;
          break;
        case "ft":
          mmValue = value * 304.8;
          break;
      }

      // Convert from mm to target unit
      switch (toUnit) {
        case "mm":
          return mmValue;
        case "cm":
          return mmValue / 10;
        case "m":
          return mmValue / 1000;
        case "in":
          return mmValue / 25.4;
        case "ft":
          return mmValue / 304.8;
        default:
          return mmValue;
      }
    };

    // REPLACE the units array (around line 720) with this updated order:
    const units = [
      { value: "mm", label: "Millimeters" },
      { value: "cm", label: "Centimeters" },
      { value: "m", label: "Meters" },
      { value: "in", label: "Inches" },
      { value: "ft", label: "Feet" },
    ];

    const hasInput = inputValue.trim().length > 0;
    const canSend =
      hasInput &&
      !isLoading &&
      // connectionStatus === "connected" &&
      !isModelLoading &&
      !isAnyButtonLoading;
    const hasSelection = parsedSelection.length > 0;

    // Auto-focus input on desktop (not mobile/tablet)
    useEffect(() => {
      const isDesktop = window.innerWidth > 1082; // Match your mobile breakpoint

      if (isDesktop && inputTextareaRef.current && chatMessages.length === 0) {
        // Small delay to ensure DOM is ready
        const timer = setTimeout(() => {
          inputTextareaRef.current?.focus();
        }, 100);

        return () => clearTimeout(timer);
      }
    }, [chatMessages.length]);

    const handleStopIconClick = () => {
      // console.log("stopped");
    };

    const handleRestoreClick = async (messageId: number) => {
      const buttonKey = `restore-${messageId}`;

      // Set loading state IMMEDIATELY
      setLoadingButtons((prev) => ({
        ...prev,
        [buttonKey]: true,
      }));

      // DON'T hide tooltip - let it change to "Branching..."
      // handleTooltipHide(`restore-${messageId}`);  // REMOVED

      try {
        // Keep button in loading state until project fully loads
        await onRestoreToOperation?.(messageId);

        // Add a delay to ensure new project has loaded
        await new Promise((resolve) => setTimeout(resolve, 2000));
      } catch (error) {
        // console.error("Restore failed:", error);
      } finally {
        // Clear loading state
        setLoadingButtons((prev) => ({
          ...prev,
          [buttonKey]: false,
        }));
      }
    };

    const handleVersionNavigate = async (
      messageId: number,
      direction: "back" | "forward",
    ) => {
      const buttonKey = `${
        direction === "back" ? "previous" : "next"
      }-${messageId}`;

      // Set loading state IMMEDIATELY
      setLoadingButtons((prev) => ({
        ...prev,
        [buttonKey]: true,
      }));

      handleTooltipHide(
        `${direction === "back" ? "previous" : "next"}-${messageId}`,
      );

      // Force multiple render cycles to ensure loading icon appears
      await new Promise((resolve) => requestAnimationFrame(resolve));
      await new Promise((resolve) => requestAnimationFrame(resolve));

      try {
        // This will trigger the entire navigation process including command replay AND save
        await onNavigateOperationVersion?.(messageId, direction);

        // NOW remove error messages after successful navigation AND save
        setChatMessages((prev) => {
          const filtered = [];
          for (let i = 0; i < prev.length; i += 2) {
            const userMsg = prev[i];
            const assistantMsg = prev[i + 1];

            if (!assistantMsg || assistantMsg.responseType !== "error") {
              filtered.push(userMsg);
              if (assistantMsg) {
                filtered.push(assistantMsg);
              }
            }
          }
          return filtered;
        });
      } catch (error) {
        // console.error("Navigation failed:", error);
      } finally {
        // Wait a bit to ensure UI has updated
        await new Promise((resolve) => setTimeout(resolve, 100));

        // Clear loading state - navigation AND save are now complete
        setLoadingButtons((prev) => ({
          ...prev,
          [buttonKey]: false,
        }));
      }
    };

    return (
      <div
        className={`${styles.sidebar} ${chatMessages.length === 0 || !projectId ? styles.fullWidth : ""}`}
      >
        {/* Header with file name - only show when a file is open */}
        {activeModelId && (
          <div
            className={styles.header}
            style={{
              borderBottomColor: isHeaderScrolled
                ? "var(--color-border)"
                : "transparent",
            }}
          >
            <span
              ref={(el) => {
                if (activeModelId) {
                  editableFileNameRef.current = el;
                }
              }}
              contentEditable={isEditingFileName && !isActiveTabShared}
              suppressContentEditableWarning
              className={styles.fileName}
              onKeyDown={(e) =>
                isEditingFileName && !isActiveTabShared
                  ? handleFileNameKeyDown(e)
                  : undefined
              }
              onBlur={() =>
                isEditingFileName && !isActiveTabShared
                  ? handleFileNameBlur()
                  : undefined
              }
              onClick={(e) => {
                if (
                  activeModelId &&
                  !isLoading &&
                  !isEditingFileName &&
                  !isActiveTabShared
                ) {
                  e.stopPropagation();
                  handleFileNameEdit();
                }
              }}
              style={{
                cursor:
                  activeModelId &&
                  !isLoading &&
                  !isEditingFileName &&
                  !isActiveTabShared
                    ? "text"
                    : "inherit",
              }}
            >
              {(() => {
                const currentTab = (window as any).__openModels?.find(
                  (m: any) => m.id === activeModelId,
                );
                return currentTab?.name || "Untitled";
              })()}
            </span>

            {/* Share Button */}
            {/* {!isActiveTabShared && (
              <div
                className={styles.shareButtonContainer}
                ref={shareDropdownRef}
              >
                <button
                  className={`${styles.shareButton} ${
                    isShareDropdownOpen ? styles.shareButtonActive : ""
                  }`}
                  onClick={() => setIsShareDropdownOpen(!isShareDropdownOpen)}
                >
                  <img
                    src={localIsPublic ? publicIconDefault : privateIconDefault}
                    alt={localIsPublic ? "Public" : "Private"}
                    className={styles.shareButtonIcon}
                  />
                  <span className={styles.shareButtonText}>Share</span>
                </button>

                {isShareDropdownOpen && (
                  <div className={styles.shareDropdown}>
                    <div
                      className={`${styles.shareOption} ${
                        !localIsPublic ? styles.shareOptionSelected : ""
                      }`}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleSharePrivateClick();
                      }}
                    >
                      <div className={styles.shareOptionContent}>
                        <div className={styles.shareOptionMain}>Private</div>
                        <div className={styles.shareOptionSub}>
                          Only you can edit
                        </div>
                      </div>
                    </div>
                    <div
                      className={`${styles.shareOption} ${
                        localIsPublic ? styles.shareOptionSelected : ""
                      }`}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleSharePublicClick();
                      }}
                    >
                      <div className={styles.shareOptionContent}>
                        <div className={styles.shareOptionMain}>Public</div>
                        <div className={styles.shareOptionSub}>
                          Anyone with the link can view
                        </div>
                        {localIsPublic && localShareToken && (
                          <div
                            className={styles.shareLinkBox}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleCopyShareLink();
                            }}
                          >
                            <div className={styles.shareLinkText}>
                              {`${window.location.origin}/share/${localShareToken}`}
                            </div>
                            <div className={styles.copyShareIcon}>
                              <img
                                src={
                                  isCopiedShare ? checkIconShare : copyIconShare
                                }
                                alt={isCopiedShare ? "Copied" : "Copy"}
                                className={styles.copyIcon}
                              />
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )} */}
          </div>
        )}
        <div className={styles.content}>
          {chatMessages.length === 0 ? (
            // Centered empty state
            <>
              <div className={styles.centeredEmptyState}>
                <h1 className={styles.emptyStateTitle}>
                  What do you want to build, {userFirstName}?
                </h1>
                {/* Input area - same structure but centered */}

                <div
                  ref={inputAreaRef}
                  className={styles.inputArea}
                  style={{ marginTop: 0, marginBottom: 0, width: "100%" }}
                >
                  <div className={styles.emptyStateInputSection}>
                    {/* Mention Menu */}
                    {showMentionMenu && filteredMentions.length > 0 && (
                      <div className={styles.mentionMenu} ref={mentionMenuRef}>
                        {filteredMentions.map((feature, index) => (
                          <div
                            key={feature.id}
                            className={`${styles.mentionItem} ${
                              index === selectedMentionIndex
                                ? styles.mentionItemSelected
                                : ""
                            }`}
                            onClick={() => handleMentionSelect(feature)}
                            onMouseEnter={() => setSelectedMentionIndex(index)}
                          >
                            <img
                              src={getIcon(featureIconLight, featureIconDark)}
                              alt={feature.type}
                              className={styles.mentionItemIcon}
                            />
                            <span className={styles.mentionItemText}>
                              {feature.displayName}
                            </span>
                          </div>
                        ))}
                      </div>
                    )}

                    {/* ROW 1: INPUT */}
                    <div className={styles.inputWrapper}>
                      <textarea
                        ref={inputTextareaRef}
                        value={inputValue}
                        onChange={handleInputChange}
                        onKeyDown={handleKeyDown}
                        placeholder={typingPlaceholder}
                        className={styles.textInput}
                        disabled={false}
                        rows={1}
                      />
                      {inputValue && (
                        <div className={styles.inputHighlightOverlay}>
                          {renderHighlightedInput()}
                        </div>
                      )}
                    </div>

                    {/* ROW 2: MODEL BUTTON */}
                    <div className={styles.inputBottomRow}>
                      <div className={styles.modelOptionsContainer}>
                        <button
                          ref={modelButtonRef}
                          className={`${styles.unitButton} ${
                            showModelMenu ? styles.unitButtonOpen : ""
                          }`}
                          onClick={() => setShowModelMenu(!showModelMenu)}
                          onMouseEnter={() => setIsModelButtonHovered(true)}
                          onMouseLeave={() => setIsModelButtonHovered(false)}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "0.5rem",
                            }}
                          >
                            <span className={styles.modelIconWrapper}>
                              {
                                aiModels.find((m) => m.value === selectedModel)
                                  ?.icon
                              }
                            </span>
                            <span className={styles.unitButtonText}>
                              {aiModels.find((m) => m.value === selectedModel)
                                ?.label || "Gemini 3 Pro"}
                            </span>
                          </div>
                          <img
                            src={
                              showModelMenu || isModelButtonHovered
                                ? chevronActiveIcon
                                : chevronIcon
                            }
                            alt="Expand"
                            className={`${styles.unitChevron} ${
                              showModelMenu ? styles.unitChevronActive : ""
                            }`}
                          />
                        </button>

                        {showModelMenu && (
                          <div className={styles.modelDropdownOptions}>
                            {aiModels.map((model) => (
                              <button
                                key={model.value}
                                className={`${styles.unitButton} ${
                                  selectedModel === model.value
                                    ? styles.unitItemSelected
                                    : ""
                                }`}
                                onClick={() => {
                                  setSelectedModel(model.value);
                                  setShowModelMenu(false);
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "0.5rem",
                                  }}
                                >
                                  {model.icon}
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      alignItems: "flex-start",
                                    }}
                                  >
                                    <span className={styles.unitItemLabel}>
                                      {model.label}
                                    </span>
                                    <span className={styles.unitItemValue}>
                                      {model.provider}
                                    </span>
                                  </div>
                                </div>
                              </button>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>

                    {/* SEND BUTTON - Right side, full height */}
                    <button
                      className={`${styles.sendButton} ${
                        isLoading
                          ? styles.sendButtonLoading
                          : canSend
                            ? styles.sendButtonActive
                            : styles.sendButtonDisabled
                      }`}
                      onClick={handleSendClick}
                      disabled={!canSend || isLoading || isAnyButtonLoading}
                    >
                      {isLoading ? (
                        <img
                          src={loadingIcon}
                          alt="Loading"
                          className={`${styles.sendButtonIcon} ${styles.spinning}`}
                        />
                      ) : (
                        <img
                          src={canSend ? sendIconReversed : sendIconDisabled}
                          alt="Send"
                          className={styles.sendButtonIcon}
                        />
                      )}
                    </button>
                  </div>
                </div>

                {/* ERROR MESSAGE (Below Input) */}
                {errorMessage && (
                  <div className={styles.errorDisplay}>
                    <span className={styles.errorText}>
                      {errorMessage.message}
                    </span>
                  </div>
                )}
              </div>

              {/* Small print - OUTSIDE centeredEmptyState */}
              <p className={`${styles.smallPrint} ${styles.emptyStatePrint}`}>
                Noah can make mistakes, so double-check it.
              </p>
            </>
          ) : (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                flex: 1,
                minHeight: 0,
                overflow: "hidden",
              }}
            >
              <div className={styles.chatMessages} ref={chatMessagesRef}>
                {Array.from(
                  { length: Math.ceil(chatMessages.length / 2) },
                  (_, i) => {
                    const userMessage = chatMessages[i * 2];
                    const assistantMessage = chatMessages[i * 2 + 1];
                    const isLastMessageGroup =
                      i === Math.ceil(chatMessages.length / 2) - 1;
                    const features = assistantMessage
                      ? parseFeatures(
                          assistantMessage.featureName ||
                            assistantMessage.content,
                        )
                      : [];

                    const isAssistantReady =
                      !isLoading ||
                      !isLastMessageGroup ||
                      (currentTypingMessageId === assistantMessage?.id &&
                        typingText);

                    const shouldShowAssistantContent =
                      assistantMessage &&
                      assistantMessage.responseType !== "error" &&
                      (!isLastMessageGroup || !isLoading);

                    const getEffectiveResponseType = (originalType: string) => {
                      if (originalType === "create" && i > 0) {
                        return "modify";
                      }
                      return originalType;
                    };

                    return (
                      <div
                        key={userMessage?.id || i}
                        className={styles.messageGroup}
                      >
                        {/* User Message */}
                        {userMessage && (
                          <div
                            className={`${styles.userMessage} ${styles.slideIn}`}
                          >
                            {userMessage?.selectionContext &&
                              (() => {
                                const edges =
                                  userMessage.selectionContext.edges || 0;
                                const faces =
                                  userMessage.selectionContext.faces || 0;
                                const hasSelection = edges > 0 || faces > 0;

                                if (!hasSelection) return null;

                                const parts = [];
                                if (faces === 1) parts.push("1 Face");
                                else if (faces > 1)
                                  parts.push(`${faces} Faces`);

                                if (edges === 1) parts.push("1 Edge");
                                else if (edges > 1)
                                  parts.push(`${edges} Edges`);

                                return (
                                  <div className={styles.userMessageSelection}>
                                    <img
                                      src={selectedActiveIcon}
                                      alt="Selection"
                                      className={
                                        styles.userMessageSelectionIcon
                                      }
                                    />
                                    <span
                                      className={
                                        styles.userMessageSelectionText
                                      }
                                    >
                                      {parts.join(", ")}
                                    </span>
                                  </div>
                                );
                              })()}

                            <span>{userMessage.content}</span>
                          </div>
                        )}

                        {/* Loading indicator */}
                        {isLastMessageGroup && isLoading && userMessage && (
                          <div className={styles.loadingIndicator}>
                            <span className={styles.loadingText}>
                              {loadingMessage}
                            </span>
                          </div>
                        )}

                        {/* Thought duration */}
                        {shouldShowAssistantContent && (
                          <div className={styles.thinkingContainer}>
                            <span className={styles.thinkingText}>
                              Thought for{" "}
                              {assistantMessage.thinkingDuration || "0s"}
                            </span>
                          </div>
                        )}

                        {/* Feature Box */}
                        {shouldShowAssistantContent && features.length > 0 && (
                          <div className={styles.featureBox}>
                            {features.map((feature, idx) => (
                              <div key={idx} className={styles.featureItem}>
                                <div className={styles.featureItemLeft}>
                                  <img
                                    src={getResponseIcon(
                                      getEffectiveResponseType(
                                        assistantMessage.responseType!,
                                      ),
                                    )}
                                    alt={assistantMessage.responseType}
                                    className={styles.featureItemIcon}
                                  />
                                  <span className={styles.featureItemText}>
                                    {feature}
                                  </span>
                                </div>
                              </div>
                            ))}
                          </div>
                        )}

                        {/* Error message */}
                        {assistantMessage &&
                          assistantMessage.responseType === "error" && (
                            <div
                              className={`${styles.assistantMessage} ${styles.errorMessage}`}
                            >
                              <span className={styles.assistantMessageText}>
                                {assistantMessage.content}
                              </span>
                              {!isActiveTabShared && (
                                <button
                                  className={styles.retryButton}
                                  onClick={() =>
                                    handleRetry(assistantMessage.id)
                                  }
                                >
                                  Retry
                                </button>
                              )}
                            </div>
                          )}

                        {/* AI Response Text */}
                        {shouldShowAssistantContent &&
                          assistantMessage.aiResponseText && (
                            <p className={styles.aiResponseText}>
                              {assistantMessage.aiResponseText}
                            </p>
                          )}

                        {/* Action buttons */}
                        {shouldShowAssistantContent && (
                          <div className={styles.messageActions}>
                            {!isActiveTabShared && (
                              <>
                                <button
                                  className={styles.actionButton}
                                  onClick={() =>
                                    handleCopyMessage(
                                      userMessage.id,
                                      userMessage.content,
                                    )
                                  }
                                  onMouseEnter={() => {
                                    if (!copiedMessageStates[userMessage.id]) {
                                      handleTooltipShow(
                                        `copyUser-${userMessage.id}`,
                                      );
                                    }
                                  }}
                                  onMouseLeave={() =>
                                    handleTooltipHide(
                                      `copyUser-${userMessage.id}`,
                                    )
                                  }
                                >
                                  <img
                                    src={
                                      copiedMessageStates[userMessage.id]
                                        ? checkIcon
                                        : copyIcon
                                    }
                                    alt={
                                      copiedMessageStates[userMessage.id]
                                        ? "Copied"
                                        : "Copy"
                                    }
                                    className={styles.actionIcon}
                                  />
                                  {tooltipStates[
                                    `copyUser-${userMessage.id}`
                                  ] &&
                                    !copiedMessageStates[userMessage.id] && (
                                      <div className={styles.tooltip}>Copy</div>
                                    )}
                                </button>
                                <button
                                  className={styles.actionButton}
                                  onClick={() =>
                                    handleThumbsUp(assistantMessage.id)
                                  }
                                  onMouseEnter={() =>
                                    handleTooltipShow(
                                      `thumbsup-${assistantMessage.id}`,
                                    )
                                  }
                                  onMouseLeave={() =>
                                    handleTooltipHide(
                                      `thumbsup-${assistantMessage.id}`,
                                    )
                                  }
                                >
                                  <img
                                    src={
                                      thumbsStates[assistantMessage.id]?.up
                                        ? thumbsUpFillIcon
                                        : thumbsUpIcon
                                    }
                                    alt="Thumbs up"
                                    className={styles.actionIcon}
                                  />
                                  {tooltipStates[
                                    `thumbsup-${assistantMessage.id}`
                                  ] && (
                                    <div className={styles.tooltip}>
                                      Good response
                                    </div>
                                  )}
                                </button>
                                <button
                                  className={styles.actionButton}
                                  onClick={() =>
                                    handleThumbsDown(assistantMessage.id)
                                  }
                                  onMouseEnter={() =>
                                    handleTooltipShow(
                                      `thumbsdown-${assistantMessage.id}`,
                                    )
                                  }
                                  onMouseLeave={() =>
                                    handleTooltipHide(
                                      `thumbsdown-${assistantMessage.id}`,
                                    )
                                  }
                                >
                                  <img
                                    src={
                                      thumbsStates[assistantMessage.id]?.down
                                        ? thumbsDownFillIcon
                                        : thumbsDownIcon
                                    }
                                    alt="Thumbs down"
                                    className={styles.actionIcon}
                                  />
                                  {tooltipStates[
                                    `thumbsdown-${assistantMessage.id}`
                                  ] && (
                                    <div className={styles.tooltip}>
                                      Bad response
                                    </div>
                                  )}
                                </button>
                                <button
                                  className={styles.actionButton}
                                  onClick={() =>
                                    handleRestoreClick(assistantMessage.id)
                                  }
                                  onMouseEnter={() => {
                                    if (
                                      !loadingButtons[
                                        `restore-${assistantMessage.id}`
                                      ]
                                    ) {
                                      handleTooltipShow(
                                        `restore-${assistantMessage.id}`,
                                      );
                                    }
                                  }}
                                  onMouseLeave={() =>
                                    handleTooltipHide(
                                      `restore-${assistantMessage.id}`,
                                    )
                                  }
                                  disabled={
                                    isLoading ||
                                    isAnyButtonLoading ||
                                    loadingButtons[
                                      `restore-${assistantMessage.id}`
                                    ]
                                  }
                                >
                                  {loadingButtons[
                                    `restore-${assistantMessage.id}`
                                  ] ? (
                                    <>
                                      <img
                                        src={loadingIcon}
                                        alt="Branching"
                                        className={`${styles.actionIcon} ${styles.spinning}`}
                                      />
                                      <span className={styles.loadingLabel}>
                                        Branching
                                      </span>
                                    </>
                                  ) : (
                                    <img
                                      src={restoreIcon}
                                      alt="Branch"
                                      className={styles.actionIcon}
                                    />
                                  )}
                                  {tooltipStates[
                                    `restore-${assistantMessage.id}`
                                  ] &&
                                    !loadingButtons[
                                      `restore-${assistantMessage.id}`
                                    ] && (
                                      <div className={styles.tooltip}>
                                        Branch
                                      </div>
                                    )}
                                </button>
                              </>
                            )}
                          </div>
                        )}
                      </div>
                    );
                  },
                )}
              </div>
            </div>
          )}
        </div>

        {/* Only show input area at bottom when there ARE messages */}
        {chatMessages.length > 0 && !isActiveTabShared && (
          <>
            {hasSelection && (
              <div className={styles.selectionDisplay}>
                <span className={styles.selectionDisplayText}>
                  <img
                    src={selectedActiveIcon}
                    alt="Selection"
                    className={styles.selectionDisplayIcon}
                  />
                  {(() => {
                    const edges = parsedSelection.filter(
                      (s) => s.type === "edge",
                    ).length;
                    const faces = parsedSelection.filter(
                      (s) => s.type === "face",
                    ).length;

                    const parts = [];
                    if (faces === 1) parts.push("1 Face");
                    else if (faces > 1) parts.push(`${faces} Faces`);

                    if (edges === 1) parts.push("1 Edge");
                    else if (edges > 1) parts.push(`${edges} Edges`);

                    let displayText = parts.join(", ");

                    if (
                      edges > 0 &&
                      edgeMeasurement !== null &&
                      edgeMeasurement > 0
                    ) {
                      const convertedValue = convertUnit(
                        edgeMeasurement,
                        "mm",
                        selectedUnit,
                      );
                      displayText += ` (${convertedValue.toFixed(2)}${selectedUnit})`;
                    }

                    return displayText;
                  })()}
                </span>
                <button
                  className={styles.selectionDisplayClose}
                  onClick={handleClearSelection}
                >
                  <img
                    src={closeIcon}
                    alt="Clear"
                    className={styles.selectionDisplayCloseIcon}
                  />
                </button>
              </div>
            )}

            <div
              className={styles.inputArea}
              style={{
                marginTop: hasSelection ? "0" : "0rem",
                marginLeft: "1rem",
                marginRight: "1rem",
                width: "calc(100% - 2rem)",
              }}
            >
              <div className={styles.emptyStateInputSection}>
                {/* Mention Menu */}
                {showMentionMenu && filteredMentions.length > 0 && (
                  <div className={styles.mentionMenu} ref={mentionMenuRef}>
                    {filteredMentions.map((feature, index) => (
                      <div
                        key={feature.id}
                        className={`${styles.mentionItem} ${
                          index === selectedMentionIndex
                            ? styles.mentionItemSelected
                            : ""
                        }`}
                        onClick={() => handleMentionSelect(feature)}
                        onMouseEnter={() => setSelectedMentionIndex(index)}
                      >
                        <img
                          src={getIcon(featureIconLight, featureIconDark)}
                          alt={feature.type}
                          className={styles.mentionItemIcon}
                        />
                        <span className={styles.mentionItemText}>
                          {feature.displayName}
                        </span>
                      </div>
                    ))}
                  </div>
                )}

                {/* ROW 1: INPUT */}
                <div className={styles.inputWrapper}>
                  <textarea
                    ref={inputTextareaRef}
                    value={inputValue}
                    onChange={handleInputChange}
                    onKeyDown={handleKeyDown}
                    placeholder={`Ask Noah, @ to mention`}
                    className={styles.textInput}
                    disabled={false}
                    rows={1}
                  />
                  {inputValue && (
                    <div className={styles.inputHighlightOverlay}>
                      {renderHighlightedInput()}
                    </div>
                  )}
                </div>

                {/* ROW 2: MODEL BUTTON */}
                <div className={styles.inputBottomRow}>
                  <div className={styles.modelOptionsContainer}>
                    <button
                      ref={modelButtonRef}
                      className={`${styles.unitButton} ${
                        showModelMenu ? styles.unitButtonOpen : ""
                      }`}
                      onClick={() => setShowModelMenu(!showModelMenu)}
                      onMouseEnter={() => setIsModelButtonHovered(true)}
                      onMouseLeave={() => setIsModelButtonHovered(false)}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "0.5rem",
                        }}
                      >
                        <span className={styles.modelIconWrapper}>
                          {
                            aiModels.find((m) => m.value === selectedModel)
                              ?.icon
                          }
                        </span>
                        <span className={styles.unitButtonText}>
                          {aiModels.find((m) => m.value === selectedModel)
                            ?.label || "Gemini 3 Pro"}
                        </span>
                      </div>
                      <img
                        src={
                          showModelMenu || isModelButtonHovered
                            ? chevronActiveIcon
                            : chevronIcon
                        }
                        alt="Expand"
                        className={`${styles.unitChevron} ${
                          showModelMenu ? styles.unitChevronActive : ""
                        }`}
                      />
                    </button>

                    {showModelMenu && (
                      <div className={styles.modelDropdownOptions}>
                        {aiModels.map((model) => (
                          <button
                            key={model.value}
                            className={`${styles.unitButton} ${
                              selectedModel === model.value
                                ? styles.unitItemSelected
                                : ""
                            }`}
                            onClick={() => {
                              setSelectedModel(model.value);
                              setShowModelMenu(false);
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "0.5rem",
                              }}
                            >
                              {model.icon}
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "flex-start",
                                }}
                              >
                                <span className={styles.unitItemLabel}>
                                  {model.label}
                                </span>
                                <span className={styles.unitItemValue}>
                                  {model.provider}
                                </span>
                              </div>
                            </div>
                          </button>
                        ))}
                      </div>
                    )}
                  </div>
                </div>

                {/* SEND BUTTON - Right side, full height */}
                <button
                  className={`${styles.sendButton} ${
                    isLoading
                      ? styles.sendButtonLoading
                      : canSend
                        ? styles.sendButtonActive
                        : styles.sendButtonDisabled
                  }`}
                  onClick={handleSendClick}
                  disabled={!canSend || isLoading || isAnyButtonLoading}
                >
                  {isLoading ? (
                    <img
                      src={loadingIcon}
                      alt="Loading"
                      className={`${styles.sendButtonIcon} ${styles.spinning}`}
                    />
                  ) : (
                    <img
                      src={canSend ? sendIconReversed : sendIconDisabled}
                      alt="Send"
                      className={styles.sendButtonIcon}
                    />
                  )}
                </button>
              </div>
            </div>

            {/* ERROR MESSAGE: MOVED OUTSIDE INPUT AREA */}
            {/* ERROR MESSAGE: MOVED OUTSIDE INPUT AREA */}
            {errorMessage && (
              <div className={styles.errorDisplay}>
                <span className={styles.errorText}>{errorMessage.message}</span>
              </div>
            )}
            <p className={styles.smallPrint}>
              Noah can make mistakes, so double-check it.
            </p>
          </>
        )}

        {/* Update smallPrint to show different text based on state */}
        {chatMessages.length === 0 && (
          <>{/* <CornerLines inputAreaRef={inputAreaRef} /> */}</>
        )}

        <UserGuideModal
          isOpen={isUserGuideOpen}
          onClose={() => setIsUserGuideOpen(false)}
        />
      </div>
    );
  },
);

export default RightSidebar;
